// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:32:41.786Z
// Property: Towns on Church (ID: 6767906449167646)
// Collections: 13 amenities, 3 floorplans (live), 40 photos, 58 POIs, 3 reviews, 3 virtual tours, 6 office hours, 1 special offers (live), 19 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167646",
  "property_external_id": "1767535",
  "property_zillow_url": "https://www.zillow.com/apartments/decatur-ga/towns-on-church/CjV3fD/",
  "property_apartments_url": "https://www.apartments.com/towns-on-church-decatur-ga/9677em5/",
  "property_google_business_url": null,
  "property_linkedin_url": null,
  "property_hubspot_id": "57164436260",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "towns-on-church",
  "property_name": "Towns on Church",
  "property_website_url": "https://www.townsonchurch.com/",
  "property_domain": "https://www.townsonchurch.com/",
  "property_address": "1712 Scott Blvd",
  "property_full_address": "1712 Scott Blvd, Decatur, GA 30033",
  "property_address_1": "1712 Scott Blvd",
  "property_address_2": null,
  "property_address_city": "Decatur",
  "property_address_state": "GA",
  "property_address_zip_full": "30033",
  "property_address_zip": "30033",
  "property_address_country": "US",
  "property_address_county": "DeKalb County",
  "property_neighborhood_address": "Medlock Park",
  "property_address_latitude": "33.798102",
  "property_address_longitude": "-84.28355",
  "property_email": "TownsonChurch.RENTCafecomILS.Quinn@assist.rent",
  "property_phone": "(866) 533-2421",
  "property_call_tracking_phone": "762-728-7233",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "<p><strong>Modern Decatur townhomes with room to settle in.</strong> Discover newly built three- and four-bedroom layouts, smart-home ease, polished finishes, and low-maintenance living near Scott Boulevard—then explore your floor plan fit or schedule a tour.</p>",
  "property_long_description": "<p><strong>Modern Decatur townhomes with room to settle in.</strong> At Towns on Church, you get the ease of a newly built townhome community in North Decatur, with spacious three-bedroom layouts, smart-home technology, in-unit laundry, and polished finishes that make everyday living feel streamlined. Cook with stainless steel appliances and granite countertops, stretch out with spacious closets, and enjoy luxury flooring plus lawn maintenance that keeps your routine simple. Explore the <a href=\"/floor-plans\">Manning and Kennedy layouts</a> to find the fit that works for you.</p><p>Just off Scott Boulevard near Church Street, you’re minutes from neighborhood essentials, green escapes, and destination dining that define Decatur. Medlock Park, Clyde Shepherd Nature Preserve, Glenn Creek Nature Preserve, and Fernbank are close by for fresh-air time, while Decatur Square brings MARTA access, the Historic DeKalb Courthouse, Brick Store Pub, Leon’s Full Service, Victory Sandwich Bar, and chef-driven restaurants into easy reach. See more <a href=\"/neighborhood\">nearby highlights</a>, then come home to connected, low-maintenance townhome living.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-fb57-746a-82c1-566746f8fc9d.webp",
  "property_featured_image_media": {
    "alt_text": "Towns on Church monument sign with townhomes and street in the background",
    "public_id": "019fec34-fb57-746a-82c1-566746f8fc9d",
    "storage_key": "property/6767906449167646/019fec34-fb57-746a-82c1-566746f8fc9d.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167646/01a0c02a-1a23-72d5-9353-2c309984fb2e.mp4",
  "property_featured_video_media": {
    "public_id": "01a0c02a-1a23-72d5-9353-2c309984fb2e",
    "storage_key": "property/6767906449167646/01a0c02a-1a23-72d5-9353-2c309984fb2e.mp4",
    "thumbnail_key": "property/6767906449167646/01a0c02a-1a23-72d5-9353-2c309984fb2e_thumb.webp",
    "size_bytes": 7396042,
    "classification": "Community",
    "title": "Explore Our Beautiful Townhome Community",
    "description": "A visual tour of our charming townhome community, showcasing the exterior architecture and serene neighborhood surroundings. Discover your new home today."
  },
  "property_total_units": "45",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": "79",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.33333333333333",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, landscaping $45, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval. Pet screening is mandatory before move-in.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply; pet screening is required before move-in.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://townsatchurch.securecafe.com/onlineleasing/towns-on-church/floorplans.aspx",
  "property_resident_portal_url": "https://townsatchurch.securecafe.com/residentservices/towns-on-church/userlogin.aspx",
  "property_apply_now_url": "https://townsatchurch.securecafe.com/onlineleasing/towns-on-church/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/01a15ad2-7de2-77b8-b603-7464951ad674.webp",
  "property_primary_logo_media": {
    "alt_text": "Towns on Church logo",
    "public_id": "01a15ad2-7de2-77b8-b603-7464951ad674",
    "storage_key": "property/6767906449167646/01a15ad2-7de2-77b8-b603-7464951ad674.webp",
    "width": 360,
    "height": 360
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": null,
  "property_mono_white_logo_media": null,
  "property_mono_black_logo": null,
  "property_mono_black_logo_media": null,
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#ad9c83",
  "property_secondary_color": "#56463f",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 3",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 3.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "3.5",
  "property_sqft_range": "1766 - 1766",
  "property_sqft_min": "1766",
  "property_sqft_max": "1766",
  "property_price_range": "2955 - 3282",
  "property_price_min": "3213",
  "property_price_max": "3516",
  "property_available_units": 3,
  "property_facebook_url": null,
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJcx6tIO4H9YgRTwqewk8e26s",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Towns on Church",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Perfect Home",
  "property_home_amenities_blurb": "<p><strong>Townhome living with everyday ease built in.</strong> At Towns on Church, smart-home features, in-unit laundry, and included lawn maintenance help keep the routine simple. Three-bedroom, multi-story layouts add separation for daily life, while granite countertops, stainless steel appliances, luxury flooring, and spacious closets bring a polished finish throughout. Explore more standout details on the full amenities page.</p>",
  "property_home_floorplans_blurb": "<p><strong>Three-bedroom townhomes with room to move.</strong> Explore the Manning and Kennedy layouts at Towns on Church, each offering spacious multi-story living, open gathering areas, bedroom separation, and everyday storage. Inside, polished finishes make daily routines easier with granite countertops, stainless-steel appliances, luxury flooring, smart-home touches, in-unit laundry, and generous closets.</p>",
  "property_home_gallery_blurb": "<p><strong>Get a closer look at Towns on Church.</strong> Preview clean-lined kitchens with granite counters and stainless steel appliances, bright living areas with hardwood-style floors, and multi-story townhome layouts designed with everyday flow in mind. Browse photos of polished baths, in-home laundry, and outdoor spaces like balconies, patios, and maintained lawns—all set in Decatur’s Medlock Park area.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Nature, flavor, and Decatur access—right off Scott Boulevard.</strong> From Towns on Church, reach Clyde Shepherd Nature Preserve, Toco Hill, Lulah Hills, and Your DeKalb Farmers Market with ease. Follow Church Street to downtown Decatur for coffee, indie shops, Eddie’s Attic, and MARTA’s Blue Line, or connect quickly to Emory, CDC, I-285, and Atlanta’s eastside. Explore the neighborhood map to see what’s nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Reviews point to the details that make daily life easier.</strong> At Towns on Church, residents highlight responsive maintenance, clear communication, and a quiet setting that feels easy to come home to. Recent feedback calls out requests handled in under 24 hours, “Swift &amp; Punctual” service, and the simplicity of utilities included with base rent in one monthly bill.</p>",
  "property_neighborhood_blurb": "<p><strong>Map out a Decatur routine with nature, flavor, and city access close by.</strong> From Towns on Church in Medlock Park, you’re positioned near the shaded paths and creekside calm of Clyde Shepherd Nature Preserve, quick errands around Toco Hill and Lulah Hills, and the global aisles of Your DeKalb Farmers Market. Follow Church Street toward downtown Decatur for coffee, indie shops, live music at Eddie’s Attic, and MARTA’s Blue Line at Decatur Station, or head out via Scott Boulevard for an easy connection to Emory, CDC, I-285, and Atlanta’s eastside. It’s a neighborhood that feels practical without feeling plain—green around the edges, food-forward in every direction, and connected to the best of Decatur. Explore the map below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see the location firsthand.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Everyday ease, built into the details.</strong> At Towns on Church, your Decatur townhome is designed to keep daily life polished without adding more to your to-do list. Smart-home technology, in-unit laundry, and included lawn maintenance help streamline the routine, while a security deposit alternative offers added flexibility at move-in.</p><p>Inside, the finishes feel clean, current, and easy to live with: granite countertops, stainless steel appliances, luxury flooring, and spacious closets that support the way you actually use each room. Multi-story three-bedroom layouts give you defined spaces for cooking, relaxing, working, and recharging, with a townhome feel that stands apart from a typical apartment. Browse the <a href=\"/gallery\">photo gallery</a> to see the finishes up close, then <a href=\"/schedule-a-tour\">schedule a tour</a> when you’re ready to experience them in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your application for Towns on Church.</strong><br>Newly built three-bedroom townhomes in North Decatur offer smart-home technology, in-unit laundry, polished finishes, and low-maintenance living with lawn care included. If the Manning or Kennedy layout feels like the right fit, apply online and take the next step toward calling this community home.</p>",
  "property_contactus_blurb": "<p><strong>Questions? We’re here to help.</strong> Contact the leasing team at Towns on Church to learn more about our modern Decatur townhomes, three-bedroom layouts, smart-home features, and low-maintenance living—or reach out for directions before your visit.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Towns on Church?</strong> Start here for quick answers about the community, leasing, and everyday living in these modern Decatur townhomes. If you need more details or help finding the right layout, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Choose the three-bedroom townhome layout that fits your flow.</strong> Towns on Church keeps the decision clear with the Manning and Kennedy floor plans, both offering spacious, multi-story living with different bath configurations. Compare current availability, pricing, and layout details side by side, then choose the plan that gives you the right balance of open gathering space, bedroom separation, and everyday storage.</p><p>Inside, each home is designed for a polished, low-maintenance routine, with a granite-and-stainless kitchen, luxury flooring, smart-home touches, in-unit laundry, and generous closet space. Browse the floor plan cards below, see more finishes in the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience these Decatur townhomes in person.</p>",
  "property_gallery_blurb": "<p><strong>See the townhome details take shape.</strong> Browse the gallery for a closer look at Towns on Church, from clean-lined kitchens with granite counters and stainless steel appliances to bright living areas with hardwood-style floors and room to unwind.</p><p>Follow the photos through multi-story layouts, polished baths, in-home laundry, and outdoor moments on a balcony, patio, or maintained lawn. You’ll get a feel for how the finishes, natural light, and townhome-style flow come together in Medlock Park, then explore the <a href=\"/floor-plans\">available layouts</a> or take the next step with a <a href=\"/schedule-a-tour\">guided tour</a>.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore North Decatur from Towns on Church.</strong> Use the interactive map to find available three-bedroom townhomes, then zoom out to see how Scott Boulevard, Church Street, green escapes, dining, and MARTA access connect around your next address.</p>",
  "property_pets_blurb": "<p><strong>Room for paws, whiskers, and everyday routines.</strong> At Towns on Church, approved cats and dogs have space to settle in alongside you, with multi-story townhome layouts, easy-care floors, in-home laundry, and a patio or balcony that adds a breath of fresh air to the day. Lawn maintenance keeps outdoor upkeep simple, while the Medlock Park setting makes quick leashed strolls feel natural.</p><p>When it’s time to stretch the route, the South Peachtree Creek Trail and fenced Decatur dog parks are within easy reach. Review the pet policy details below, explore more <a href=\"/amenities\">home features</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see how pet-friendly townhome living comes together.</p>",
  "property_referafriend_blurb": "<p><strong>Share the townhome living you love.</strong> Refer a friend to Towns on Church and invite them to discover newly built three-bedroom layouts, smart-home ease, polished finishes, and a connected North Decatur location designed for low-maintenance everyday living.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident access, streamlined.</strong> Log in to pay rent, submit maintenance requests, and manage your Towns on Church account—all in one place. Keep everyday living simple, just like your low-maintenance Decatur townhome with smart-home technology, in-unit laundry, and polished finishes.</p>",
  "property_reviews_blurb": "<p><strong>Real feedback, real day-to-day details.</strong> As you read through reviews for Towns on Church, you’ll see residents call out responsive maintenance, helpful communication, and a smoother routine at home.</p><p>Recent comments highlight service that feels personal, from maintenance requests handled in less than 24 hours to team members who keep residents updated along the way. One reviewer summed it up simply: “Maintenance was Swift &amp; Punctual.” Others appreciate the convenience of utilities included with base rent and one bill, along with a peaceful, quiet environment that feels worth coming home to.</p>",
  "property_created_at": "1786374152522",
  "property_scheduletour_blurb": "<p><strong>See Towns on Church in person.</strong> Tour newly built three-bedroom townhomes with smart-home technology, in-unit laundry, polished finishes, and low-maintenance living just off Scott Boulevard. Walk the layouts, picture your routine, and book your visit today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong><br>Our leasing team will follow up soon. In the meantime, picture low-maintenance Decatur townhome living with spacious three-bedroom layouts, smart-home technology, polished finishes, and everyday ease near Scott Boulevard and Church Street.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "© 2026 Quinn Residences. All rights reserved.",
  "property_seo_title_home": "Townhomes for Rent in Decatur, GA | Towns on Church",
  "property_seo_description_home": "Explore three- and four-bedroom townhomes for rent in Decatur, GA, at Towns on Church. Discover modern living spaces and schedule your tour today.",
  "property_seo_title_floorplans": "3 & 4 Bedroom Townhomes in Decatur | Towns on Church",
  "property_seo_description_floorplans": "Explore three- and four-bedroom townhome floor plans at Towns on Church in Decatur, GA. Find a layout that fits your needs and view availability.",
  "property_seo_title_amenities": "Decatur Townhome Amenities | Towns on Church",
  "property_seo_description_amenities": "Discover Towns on Church amenities, including smart-home technology, in-home laundry, and modern finishes. Explore townhome living in Decatur, GA.",
  "property_seo_title_gallery": "Decatur Townhome Photos | Towns on Church",
  "property_seo_description_gallery": "Browse photos of Towns on Church in Decatur, GA. Explore townhome interiors, finishes, and community spaces before scheduling your in-person tour.",
  "property_seo_title_virtualtours": "Virtual Tour of Decatur Townhomes | Towns on Church",
  "property_seo_description_virtualtours": "Explore Towns on Church from wherever you are. Take a virtual look at our Decatur, GA townhomes and discover the spaces before visiting in person.",
  "property_seo_title_interactivemap": "Interactive Leasing | Towns on Church Decatur",
  "property_seo_description_interactivemap": "Explore available townhomes at Towns on Church in Decatur, GA. Use our interactive leasing experience to compare layouts and find your next home.",
  "property_seo_title_neighborhood": "Townhomes Near Downtown Decatur | Towns on Church",
  "property_seo_description_neighborhood": "Explore the neighborhood around Towns on Church in Decatur, GA. Discover nearby dining, shopping, and local destinations, then plan a visit.",
  "property_seo_title_contact": "Contact Towns on Church | Decatur, GA Townhomes",
  "property_seo_description_contact": "Have questions about townhomes for rent in Decatur, GA? Contact Towns on Church for details on floor plans, availability, and touring options.",
  "property_seo_title_faqs": "FAQs | Apartments in Decatur, GA",
  "property_seo_description_faqs": "Experience luxury living at Towns on Church in Decatur, GA. From spacious three-bedroom plans to smart-home tech, find answers to all your FAQs today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Decatur, GA",
  "property_seo_description_reviews": "Uncover what makes Towns on Church in Decatur, GA, a spacious haven. Hear from residents about luxury living with smart-home tech and stunning amenities!",
  "property_seo_title_applynow": "Apply for a Decatur Townhome | Towns on Church",
  "property_seo_description_applynow": "Ready to make your move? Start your rental application for a townhome at Towns on Church in Decatur, GA, and connect with our leasing team.",
  "property_seo_title_residentaccess": "Resident Portal | Towns on Church Decatur",
  "property_seo_description_residentaccess": "Access resident resources for Towns on Church in Decatur, GA. Visit the resident portal for available online services and community information.",
  "property_seo_title_referafriend": "Refer A Friend | Towns on Church",
  "property_seo_description_referafriend": "Refer a friend to Towns on Church in Decatur, GA! Great friends make great neighbors—share the vibrant community you love today!",
  "property_seo_title_scheduletour": "Tour Decatur Townhomes | Towns on Church",
  "property_seo_description_scheduletour": "Schedule a tour of Towns on Church in Decatur, GA. Explore three- and four-bedroom townhomes, see the features, and connect with our leasing team.",
  "property_seo_title_privacy": "Privacy Policy | Towns on Church",
  "property_seo_description_privacy": "At Towns on Church in Decatur, GA, your privacy matters. Uncover how we protect your information and ensure a secure living experience. View our policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Towns on Church",
  "property_seo_description_accessibility": "At Towns on Church in Decatur, GA, we prioritize digital inclusion. Dive into our accessibility statement and see how we create a welcoming community for all!",
  "property_seo_title_sitemap": "Sitemap | Towns on Church",
  "property_seo_description_sitemap": "Navigate your way through Towns on Church in Decatur, GA! Check out our sitemap for a glimpse of our vibrant community and exciting amenities.",
  "property_seo_title_thankyou": "Thank You | Towns on Church",
  "property_seo_description_thankyou": "Thank you for contacting Towns on Church in Decatur, GA. Our leasing team looks forward to connecting with you about our townhomes.",
  "property_seo_title_pets": "Pet-Friendly Townhomes in Decatur | Towns on Church",
  "property_seo_description_pets": "Learn about the pet policy at Towns on Church in Decatur, GA. Review pet guidelines and contact our leasing team with questions before applying.",
  "property_updated_at": "1793288945161",
  "amenities": [
    {
      "id": "ec_4bf1beb66edc2a435c7d8320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616013",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_072674527513dd5ddc943b38",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616010",
      "title": "Hardwood Floors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d88f4d135a3457ad469e3e0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616005",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ebbd92f6eb810d77e3f7a9ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616014",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c84045157cd3c2229df3e502",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616007",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_042652e00e440292503a372a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616006",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59c8f6117b19ed8347ef4f63",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616008",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4eaca0d5add49c4ff2db9a5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616012",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6aa8dc408054337f3d7c4f00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "122616001",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b78b9b8be22ba9a6f2fe2a9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "129124913",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4727ef008063eebcd06bedb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "129124933",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_03f113679bdfb9131ce2386e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "129124953",
      "title": "Smart-Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c636825de2705323a77054bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "129124966",
      "title": "In-Unit Laundry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_60454e1e5fa9d972cbeb2519",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-fb57-746a-82c1-566746f8fc9d.webp",
      "image_media": {
        "alt_text": "Towns on Church monument sign with townhomes and street in the background",
        "public_id": "019fec34-fb57-746a-82c1-566746f8fc9d",
        "storage_key": "property/6767906449167646/019fec34-fb57-746a-82c1-566746f8fc9d.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Towns on Church, a beautiful community with charming townhomes and well-maintained grounds.",
      "link": "false",
      "alt_text": "A sign that says \"Towns on Church\" is in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/3-web-or-mls-Scott%20Blvd-S2108-003.jpg"
    },
    {
      "id": "ec_838729b387ef134090263604",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c437-710d-98ac-defa6e0bcee6.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with brick accents and blue windows.",
        "public_id": "019fec34-c437-710d-98ac-defa6e0bcee6",
        "storage_key": "property/6767906449167646/019fec34-c437-710d-98ac-defa6e0bcee6.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Modern townhomes featuring elegant brick detailing, large windows, and a welcoming entryway, set against a clear blue sky.",
      "link": "false",
      "alt_text": "A modern two-story house with a grey and white exterior and a brick wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kennedy-Exterior.jpg"
    },
    {
      "id": "ec_aa4edad85b95d557254702d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-f894-7268-a00c-9e46215be774.webp",
      "image_media": {
        "alt_text": "Exterior view of townhouses with gray siding and brick accents, featuring front porches and manicured landscaping.",
        "public_id": "019fec34-f894-7268-a00c-9e46215be774",
        "storage_key": "property/6767906449167646/019fec34-f894-7268-a00c-9e46215be774.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Charming townhome exteriors showcasing a blend of modern gray siding and classic brick accents, creating an inviting streetscape.",
      "link": "false",
      "alt_text": "A grey house with a white door and windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/2-web-or-mls-Scott%20Blvd-S2108-002.jpg"
    },
    {
      "id": "ec_e1f9379bc2a04927bd3d4225",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-433b-7166-9679-cd3a066801f8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel appliances, and white cabinets.",
        "public_id": "019fec35-433b-7166-9679-cd3a066801f8",
        "storage_key": "property/6767906449167646/019fec35-433b-7166-9679-cd3a066801f8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A spacious and modern kitchen featuring granite countertops, stainless steel appliances, and ample white cabinetry, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/16-web-or-mls-Scott%20Blvd-S2108-016.jpg"
    },
    {
      "id": "ec_1937ee79f10f68be014773c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-532e-74f3-91e5-fd53747d4ba7.webp",
      "image_media": {
        "alt_text": "Spacious living room with blue sofas, large windows, and plants.",
        "public_id": "019fec35-532e-74f3-91e5-fd53747d4ba7",
        "storage_key": "property/6767906449167646/019fec35-532e-74f3-91e5-fd53747d4ba7.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy relaxing in this beautifully appointed living room, featuring comfortable seating, ample natural light, and stylish decor.",
      "link": "false",
      "alt_text": "A living room with a grey couch, a brown ottoman, a coffee table, and a potted plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/5-web-or-mls-Scott%20Blvd-S2108-005.jpg"
    },
    {
      "id": "ec_149b92071d31be01e69b8a5a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-2a39-7539-90b8-4692434abade.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, bedside tables, and a large wooden mirror.",
        "public_id": "019fec35-2a39-7539-90b8-4692434abade",
        "storage_key": "property/6767906449167646/019fec35-2a39-7539-90b8-4692434abade.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious and stylish bedroom featuring a king-size bed, decorative pillows, and a large wooden mirror. Ample natural light fills the room through multiple windows.",
      "link": "false",
      "alt_text": "A bedroom with a large bed and a large mirror on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/24-web-or-mls-Scott%20Blvd-S2108-024.jpg"
    },
    {
      "id": "ec_d39efdb912de11907cf67635",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-0bb9-71fe-8773-bbfec1885a3e.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, ceiling fan, large mirror, and windows overlooking the street.",
        "public_id": "019fec35-0bb9-71fe-8773-bbfec1885a3e",
        "storage_key": "property/6767906449167646/019fec35-0bb9-71fe-8773-bbfec1885a3e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-size bed, a decorative ceiling fan, and a full-length mirror. Large windows provide ample natural light and street views.",
      "link": "false",
      "alt_text": "A bedroom with a bed, pillows, a ceiling fan, and a window with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/25-web-or-mls-Scott%20Blvd-S2108-025.jpg"
    },
    {
      "id": "ec_0424ace2c79b3df60db1613e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-1640-7008-b5cd-b54522b3d1d6.webp",
      "image_media": {
        "alt_text": "Dining area with a table and chairs",
        "public_id": "019fec35-1640-7008-b5cd-b54522b3d1d6",
        "storage_key": "property/6767906449167646/019fec35-1640-7008-b5cd-b54522b3d1d6.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy meals with family and friends in this inviting dining area, featuring a stylish table and comfortable seating.",
      "link": "false",
      "alt_text": "A dining room with a table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/11-web-or-mls-Scott%20Blvd-S2108-011.jpg"
    },
    {
      "id": "ec_769c36769ba3c99be0455719",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-f6a5-70cc-bb4f-f67a17c4c4aa.webp",
      "image_media": {
        "alt_text": "A home office with a desk, chairs, and a bookshelf.",
        "public_id": "019fec34-f6a5-70cc-bb4f-f67a17c4c4aa",
        "storage_key": "property/6767906449167646/019fec34-f6a5-70cc-bb4f-f67a17c4c4aa.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This stylish home office features a modern desk, comfortable seating, and a chic bookshelf, perfect for remote work or study.",
      "link": "false",
      "alt_text": "A living room with a brown chair and a wooden table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/17-web-or-mls-Scott%20Blvd-S2108-017.jpg"
    },
    {
      "id": "ec_c0a1ea6bb04ba1fb8adb4132",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-a5d2-72ac-be6c-7feed28e43a8.webp",
      "image_media": {
        "alt_text": "Townhomes at Towns on Church with a monument sign",
        "public_id": "019fec34-a5d2-72ac-be6c-7feed28e43a8",
        "storage_key": "property/6767906449167646/019fec34-a5d2-72ac-be6c-7feed28e43a8.webp",
        "width": 3072,
        "height": 2153
      },
      "title": "Community",
      "description": "Exterior view of modern townhomes at Towns on Church, featuring a welcoming monument sign and well-maintained landscaping.",
      "link": "false",
      "alt_text": "A white building with a sign that says \"Towns on Church\".",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Community-Front-Row.jpg"
    },
    {
      "id": "ec_c550b0d1337748a585b2b5d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-5bd1-7781-9e7f-727ac1a5a9c8.webp",
      "image_media": {
        "alt_text": "White stacked washer and dryer in a closet.",
        "public_id": "019fec35-5bd1-7781-9e7f-727ac1a5a9c8",
        "storage_key": "property/6767906449167646/019fec35-5bd1-7781-9e7f-727ac1a5a9c8.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "Two white washing machines in a laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/31-web-or-mls-Scott%20Blvd-S2108-031.jpg"
    },
    {
      "id": "ec_ef6232ba740fd748daaedb34",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c30a-721b-ad73-28600c1cb12b.webp",
      "image_media": {
        "alt_text": "Exterior of townhomes with light gray siding, dark blue doors, and brick accents.",
        "public_id": "019fec34-c30a-721b-ad73-28600c1cb12b",
        "storage_key": "property/6767906449167646/019fec34-c30a-721b-ad73-28600c1cb12b.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Community",
      "description": "Charming townhome exteriors featuring light gray siding, classic brick foundations, and inviting dark blue front doors.",
      "link": "false",
      "alt_text": "A house with a blue door and a black railing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Community-Front-Row-Close-up.jpg"
    },
    {
      "id": "ec_31a16f27723781860212959f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c637-77a1-aa8c-7b9a69a2abf2.webp",
      "image_media": {
        "alt_text": "Aerial view of a courtyard with townhomes on either side and a walking path.",
        "public_id": "019fec34-c637-77a1-aa8c-7b9a69a2abf2",
        "storage_key": "property/6767906449167646/019fec34-c637-77a1-aa8c-7b9a69a2abf2.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Beautiful courtyard area featuring townhomes with manicured lawns and walkways.",
      "link": "false",
      "alt_text": "A view of a courtyard between two buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Community-Aerial.jpg"
    },
    {
      "id": "ec_1d6d9bb810033980a7065f6b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c2a9-7409-954b-df736f4a9d8e.webp",
      "image_media": {
        "alt_text": "Row of modern townhouses with manicured lawns and walkways.",
        "public_id": "019fec34-c2a9-7409-954b-df736f4a9d8e",
        "storage_key": "property/6767906449167646/019fec34-c2a9-7409-954b-df736f4a9d8e.webp",
        "width": 1280,
        "height": 902
      },
      "title": "Community",
      "description": "Charming row of townhouses featuring pristine landscaping, clean walkways, and well-maintained exteriors, offering a welcoming neighborhood feel.",
      "link": "false",
      "alt_text": "A white house with a grey roof and a green lawn in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Community-Aerial-2.jpg"
    },
    {
      "id": "ec_94cd2ca94510e41f3812e11a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-c1dc-7115-b09a-475d4d7f9b10.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment kitchen and living area with stairs.",
        "public_id": "019fec34-c1dc-7115-b09a-475d4d7f9b10",
        "storage_key": "property/6767906449167646/019fec34-c1dc-7115-b09a-475d4d7f9b10.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and bright open-concept living area featuring a modern kitchen with stainless steel appliances, a large island, and sleek cabinetry. An elegant staircase leads to the upper level.",
      "link": "false",
      "alt_text": "A kitchen with a refrigerator, microwave, and oven is visible from the staircase.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kennedy-Dining-Room.jpg"
    },
    {
      "id": "ec_70c7941d88796fb1fcb56765",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-d16e-716f-b5f8-12e0d54f6eac.webp",
      "image_media": {
        "alt_text": "Spacious open-concept living room and kitchen area with light wood floors and white walls.",
        "public_id": "019fec34-d16e-716f-b5f8-12e0d54f6eac",
        "storage_key": "property/6767906449167646/019fec34-d16e-716f-b5f8-12e0d54f6eac.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy the open-concept layout of this apartment, featuring a modern kitchen and spacious living area perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "A spacious room with a ceiling fan and wooden flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kennedy-Living-Room-Cropped.jpg"
    },
    {
      "id": "ec_ea01ad3eae144c33c4ece60f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-d623-7768-a714-9df7b1d7b694.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and doors leading to a closet and bathroom.",
        "public_id": "019fec34-d623-7768-a714-9df7b1d7b694",
        "storage_key": "property/6767906449167646/019fec34-d623-7768-a714-9df7b1d7b694.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space, and an en-suite bathroom with a glass-enclosed shower.",
      "link": "false",
      "alt_text": "A room with a ceiling fan and light, hardwood floors, and white walls with two doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kennedy-Primary-Bedroom.jpg"
    },
    {
      "id": "ec_2939d7b36b9ea5dac9179c9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-d8e9-74c8-ba34-f5e17274c519.webp",
      "image_media": {
        "alt_text": "Exterior deck with view of apartment buildings",
        "public_id": "019fec34-d8e9-74c8-ba34-f5e17274c519",
        "storage_key": "property/6767906449167646/019fec34-d8e9-74c8-ba34-f5e17274c519.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Enjoy your private outdoor space on the deck, offering a picturesque view of the surrounding apartment buildings and lush greenery.",
      "link": "false",
      "alt_text": "A wooden deck leads to a large white building with a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Kennedy-Backyard.jpg"
    },
    {
      "id": "ec_00d0cbcdc3fb4ee01de4d6ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-d782-73af-bc49-6465edbe64a8.webp",
      "image_media": {
        "alt_text": "Exterior of townhome buildings with brick and siding.",
        "public_id": "019fec34-d782-73af-bc49-6465edbe64a8",
        "storage_key": "property/6767906449167646/019fec34-d782-73af-bc49-6465edbe64a8.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Modern townhomes with a mix of brick and siding exteriors, featuring multiple windows and covered entryways.",
      "link": "false",
      "alt_text": "A row of townhouses with different colored trim.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Manning-Exterior.jpg"
    },
    {
      "id": "ec_8ad1c8f9d0cb301700cee468",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-e765-773d-a80b-611e0bd67e55.webp",
      "image_media": {
        "alt_text": "View from a wooden deck with a privacy screen, overlooking a street with townhouses and a blue sky.",
        "public_id": "019fec34-e765-773d-a80b-611e0bd67e55",
        "storage_key": "property/6767906449167646/019fec34-e765-773d-a80b-611e0bd67e55.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy private outdoor living on your spacious wooden deck, offering beautiful views of the charming neighborhood street and townhouses.",
      "link": "false",
      "alt_text": "A wooden deck with a bench and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Manning-Deck.jpg"
    },
    {
      "id": "ec_e28b129dce8ccc3b2d8af2a6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-dbb2-7628-9f6a-9d6c7245f0ef.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and a large island.",
        "public_id": "019fec34-dbb2-7628-9f6a-9d6c7245f0ef",
        "storage_key": "property/6767906449167646/019fec34-dbb2-7628-9f6a-9d6c7245f0ef.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and contemporary kitchen featuring a double-door refrigerator, microwave, range, and an island with a sink, perfect for entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with a granite countertop and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Manning-Kitchen.jpg"
    },
    {
      "id": "ec_32008414323a13500de6f572",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-e32a-7429-8676-b7f72802fdd1.webp",
      "image_media": {
        "alt_text": "Spacious living room and kitchen area with light wood floors, white cabinets, and a ceiling fan.",
        "public_id": "019fec34-e32a-7429-8676-b7f72802fdd1",
        "storage_key": "property/6767906449167646/019fec34-e32a-7429-8676-b7f72802fdd1.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Open-concept living and kitchen area featuring light wood flooring, modern white cabinetry, and a central island. Perfect for entertaining and everyday living.",
      "link": "false",
      "alt_text": "A spacious room with a ceiling fan and wooden flooring.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Manning-Living-Room.jpg"
    },
    {
      "id": "ec_c8bad0635578b3944ee69e75",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-ea2e-773c-be10-2ad42e055444.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with brick and siding.",
        "public_id": "019fec34-ea2e-773c-be10-2ad42e055444",
        "storage_key": "property/6767906449167646/019fec34-ea2e-773c-be10-2ad42e055444.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Charming townhomes featuring a mix of brick and siding exteriors, with well-maintained landscaping and inviting entrances.",
      "link": "false",
      "alt_text": "A modern two-story house with a mix of grey and beige siding.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Richard-Exterior-2.jpg"
    },
    {
      "id": "ec_bf22dad5bedbf9be10d58ad5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-e915-72ee-90b8-37742e933825.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and island.",
        "public_id": "019fec34-e915-72ee-90b8-37742e933825",
        "storage_key": "property/6767906449167646/019fec34-e915-72ee-90b8-37742e933825.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, a granite countertop island, and ample cabinet space. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A kitchen with a refrigerator, microwave, and oven.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Richard-Living-Room.jpg"
    },
    {
      "id": "ec_ac10faf2f49e111182eb3b95",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-f1fd-70c9-be40-bff02f70ac2e.webp",
      "image_media": {
        "alt_text": "Balcony overlooking the street with townhouses and shops nearby.",
        "public_id": "019fec34-f1fd-70c9-be40-bff02f70ac2e",
        "storage_key": "property/6767906449167646/019fec34-f1fd-70c9-be40-bff02f70ac2e.webp",
        "width": 1280,
        "height": 900
      },
      "title": "Community",
      "description": "Enjoy fresh air and views from your private balcony, situated in a vibrant neighborhood close to shops and dining.",
      "link": "false",
      "alt_text": "A wooden deck with a red railing and a white door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Richard-Deck.jpg"
    },
    {
      "id": "ec_08630c4734a30b65f2ad1b1a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec34-ef50-7589-99c4-48476c12b456.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop, white vanity, and a bathtub with a decorative shower curtain.",
        "public_id": "019fec34-ef50-7589-99c4-48476c12b456",
        "storage_key": "property/6767906449167646/019fec34-ef50-7589-99c4-48476c12b456.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Discover comfort and style in our modern bathrooms, featuring elegant granite countertops, spacious vanities, and a relaxing bathtub.",
      "link": "false",
      "alt_text": "A bathroom with a white counter top and a painting on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/26-web-or-mls-Scott%20Blvd-S2108-026.jpg"
    },
    {
      "id": "ec_686a61b3d5104ca1842852be",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-0197-7586-960c-fd8033c8a877.webp",
      "image_media": {
        "alt_text": "Towns on Church monument sign",
        "public_id": "019fec35-0197-7586-960c-fd8033c8a877",
        "storage_key": "property/6767906449167646/019fec35-0197-7586-960c-fd8033c8a877.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Towns on Church, a Quinn Residence. Discover your new home today.",
      "link": "false",
      "alt_text": "A sign that says Towns on Church stands in front of a building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/4-web-or-mls-Scott%20Blvd-S2108-004.jpg"
    },
    {
      "id": "ec_8115ba2e37e72e485b62ce90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-013f-7518-ac5d-5bef7280e35a.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with white wire shelving and a window.",
        "public_id": "019fec35-013f-7518-ac5d-5bef7280e35a",
        "storage_key": "property/6767906449167646/019fec35-013f-7518-ac5d-5bef7280e35a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This empty walk-in closet features ample space with convenient white wire shelving and a large window offering natural light.",
      "link": "false",
      "alt_text": "Empty walk-in closet with white wire shelving and a window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/28-web-or-mls-Scott%20Blvd-S2108-028.jpg"
    },
    {
      "id": "ec_d91f0ace021e69e0e42557d1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-1394-70ff-8cff-aa42a8e3cadf.webp",
      "image_media": {
        "alt_text": "Exterior of townhomes with attached garages and decks.",
        "public_id": "019fec35-1394-70ff-8cff-aa42a8e3cadf",
        "storage_key": "property/6767906449167646/019fec35-1394-70ff-8cff-aa42a8e3cadf.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Townhome exteriors featuring private decks and attached garages.",
      "link": "false",
      "alt_text": "A stop sign is on the corner of a street.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/35-web-or-mls-Scott%20Blvd-S2108-035.jpg"
    },
    {
      "id": "ec_48c2ce990cf923954a34a9ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-19c6-71ef-9fdf-cbfce865fd19.webp",
      "image_media": {
        "alt_text": "Private balcony with outdoor table and chairs overlooking townhomes.",
        "public_id": "019fec35-19c6-71ef-9fdf-cbfce865fd19",
        "storage_key": "property/6767906449167646/019fec35-19c6-71ef-9fdf-cbfce865fd19.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, complete with outdoor seating and views of the charming neighborhood.",
      "link": "false",
      "alt_text": "Private balcony with outdoor table and chairs overlooking townhomes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/33-web-or-mls-Scott%20Blvd-S2108-033.jpg"
    },
    {
      "id": "ec_deadc8a213bf0b908c950def",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-1d54-774b-8bbf-d1f6e553efdb.webp",
      "image_media": {
        "alt_text": "Modern home office with a desk, chairs, and stairs.",
        "public_id": "019fec35-1d54-774b-8bbf-d1f6e553efdb",
        "storage_key": "property/6767906449167646/019fec35-1d54-774b-8bbf-d1f6e553efdb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This bright and airy space features a home office area with a stylish desk and comfortable seating, perfect for remote work or study.",
      "link": "false",
      "alt_text": "Modern home office with a desk, chairs, and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/18-web-or-mls-Scott%20Blvd-S2108-018.jpg"
    },
    {
      "id": "ec_a06e5068e8510e931d7916d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-2461-731e-bbea-d6c67bcb10df.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with garages and elevated decks on a sunny day.",
        "public_id": "019fec35-2461-731e-bbea-d6c67bcb10df",
        "storage_key": "property/6767906449167646/019fec35-2461-731e-bbea-d6c67bcb10df.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Modern townhomes featuring attached garages and spacious elevated decks, offering comfortable living spaces with attractive exteriors.",
      "link": "false",
      "alt_text": "A two story building with a balcony on the second floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/34-web-or-mls-Scott%20Blvd-S2108-034.jpg"
    },
    {
      "id": "ec_5e50f9c999ed00d915cfd687",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-2db1-713b-83a3-eeb63a047373.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, granite countertops, and glass-enclosed shower.",
        "public_id": "019fec35-2db1-713b-83a3-eeb63a047373",
        "storage_key": "property/6767906449167646/019fec35-2db1-713b-83a3-eeb63a047373.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Experience luxury in this stunning bathroom, featuring a double vanity with granite countertops and a spacious glass-enclosed shower.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/27-web-or-mls-Scott%20Blvd-S2108-027.jpg"
    },
    {
      "id": "ec_3df4e733d32e1e6368169f25",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-3392-7028-b379-8b27b7c31b9a.webp",
      "image_media": {
        "alt_text": "Towns on Church monument sign and exterior of townhomes.",
        "public_id": "019fec35-3392-7028-b379-8b27b7c31b9a",
        "storage_key": "property/6767906449167646/019fec35-3392-7028-b379-8b27b7c31b9a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Welcome to Towns on Church, a Quinn Residence. Featuring beautiful townhomes with modern exteriors and lush landscaping.",
      "link": "false",
      "alt_text": "A grey building with a sign that says \"Towns on Church\".",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/1-web-or-mls-Scott%20Blvd-S2108-001.jpg"
    },
    {
      "id": "ec_0db47ecd5e89ce417d63c681",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-3530-7210-8577-71baddcc9d12.webp",
      "image_media": {
        "alt_text": "Vanity with granite countertop and sink, reflected in a large mirror.",
        "public_id": "019fec35-3530-7210-8577-71baddcc9d12",
        "storage_key": "property/6767906449167646/019fec35-3530-7210-8577-71baddcc9d12.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A stylish bathroom vanity featuring a granite countertop, undermount sink, and a large mirror, perfect for any modern apartment.",
      "link": "false",
      "alt_text": "A bathroom with a granite counter top and a round sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/30-web-or-mls-Scott%20Blvd-S2108-030.jpg"
    },
    {
      "id": "ec_d294284e22683860ceee1589",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-3e42-744d-9317-2dd79a45ec3c.webp",
      "image_media": {
        "alt_text": "Deck with table and chairs, sliding glass door opening to living room with kitchen island.",
        "public_id": "019fec35-3e42-744d-9317-2dd79a45ec3c",
        "storage_key": "property/6767906449167646/019fec35-3e42-744d-9317-2dd79a45ec3c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy your private deck with an outdoor seating area, perfect for relaxing or entertaining guests. The sliding glass door provides easy access to your open-concept living space and kitchen.",
      "link": "false",
      "alt_text": "Deck with table and chairs, sliding glass door opening to living room with kitchen island.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/32-web-or-mls-Scott%20Blvd-S2108-032.jpg"
    },
    {
      "id": "ec_ba9a1284aeb3a3ef8d8ba49e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-4390-70fc-87f4-5d4ada8d2d2a.webp",
      "image_media": {
        "alt_text": "Interior view of a room with two doors, a window with blinds, and framed artwork on the wall.",
        "public_id": "019fec35-4390-70fc-87f4-5d4ada8d2d2a",
        "storage_key": "property/6767906449167646/019fec35-4390-70fc-87f4-5d4ada8d2d2a.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "A bright and spacious interior room featuring two doors, one ajar revealing another room, a window with blinds, and a modern framed piece of art on the wall. The neutral color palette and light wood flooring create a welcoming ambiance.",
      "link": "false",
      "alt_text": "A hallway with a white door and a framed picture on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/20-web-or-mls-Scott%20Blvd-S2108-020.jpg"
    },
    {
      "id": "ec_4f320e968aede7bd2eaa036d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-4910-7078-9718-679b3598121c.webp",
      "image_media": {
        "alt_text": "Modern kitchen with island and bar stools, stainless steel appliances, and dining area.",
        "public_id": "019fec35-4910-7078-9718-679b3598121c",
        "storage_key": "property/6767906449167646/019fec35-4910-7078-9718-679b3598121c.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Expansive open-concept kitchen featuring a large island with seating, stainless steel appliances, and a connected dining space. Perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with island and bar stools, stainless steel appliances, and dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/14-web-or-mls-Scott%20Blvd-S2108-014.jpg"
    },
    {
      "id": "ec_854918990934818f931ac2bf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-580e-72ee-87c8-8ac4835cd1cd.webp",
      "image_media": {
        "alt_text": "Empty room with wood-look flooring, a framed picture on the wall, a mirror, and two windows.",
        "public_id": "019fec35-580e-72ee-87c8-8ac4835cd1cd",
        "storage_key": "property/6767906449167646/019fec35-580e-72ee-87c8-8ac4835cd1cd.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "This empty room features wood-look flooring, a framed picture on the wall, a mirror, and two windows with blinds. Ideal for use as a bedroom or office.",
      "link": "false",
      "alt_text": "A room with a window and a picture on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/21-web-or-mls-Scott%20Blvd-S2108-021.jpg"
    },
    {
      "id": "ec_6a1771682dbf230c8ebfce77",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-5a3d-73f9-94e7-5f14f757134b.webp",
      "image_media": {
        "alt_text": "Modern dining area with a table and chairs, open to a kitchen with an island and stainless steel appliances.",
        "public_id": "019fec35-5a3d-73f9-94e7-5f14f757134b",
        "storage_key": "property/6767906449167646/019fec35-5a3d-73f9-94e7-5f14f757134b.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Apartment",
      "description": "Enjoy meals in this stylish dining area, perfectly connected to a modern kitchen featuring a convenient island and sleek stainless steel appliances.",
      "link": "false",
      "alt_text": "A modern dining room with a wooden table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/12-web-or-mls-Scott%20Blvd-S2108-012.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_9c7209c1-8001-4b60-82d1-f6bc02f4fa20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Brick Store Pub",
      "poi_type": "Restaurants",
      "poi_address": "125 E Court Square, Decatur, GA 30030, USA",
      "poi_short_description": "Casual pub grub like fish 'n' chips is served at this beer-focused tavern with upstairs Belgian Bar.",
      "poi_long_description": "Casual pub grub like fish 'n' chips is served at this beer-focused tavern with upstairs Belgian Bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-9e7d-75ae-ae77-81e9c95542b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-9e7d-75ae-ae77-81e9c95542b4",
        "storage_key": "property/6767906449167646/019fec35-9e7d-75ae-ae77-81e9c95542b4.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.brickstorepub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12591048437404188738",
      "poi_item_slug": "brick-store-pub",
      "poi_latitude": "33.775135",
      "poi_longitude": "-84.2957993",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-687-0960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-9ff5-769c-b239-24697ad2db11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec36-9ff5-769c-b239-24697ad2db11",
        "storage_key": "property/6767906449167646/019fec36-9ff5-769c-b239-24697ad2db11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJf_XS6z0H9YgRQsA29ddjvK4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_706accaa-9898-43f2-9cc7-f19dba0f64f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Kimball House",
      "poi_type": "Restaurants",
      "poi_address": "303 E Howard Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Once a railroad station, this sleek eatery & raw bar serves farm-to-table entrees with French flair.",
      "poi_long_description": "Once a railroad station, this sleek eatery & raw bar serves farm-to-table entrees with French flair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-a470-727a-a7f5-83f03edec2bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-a470-727a-a7f5-83f03edec2bc",
        "storage_key": "property/6767906449167646/019fec35-a470-727a-a7f5-83f03edec2bc.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.kimball-house.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14008844166532029459",
      "poi_item_slug": "kimball-house",
      "poi_latitude": "33.771596",
      "poi_longitude": "-84.29228189999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-378-3502",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJHatDOT8H9YgRE9zxI4xpacI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_75e157f9-8030-49b4-b59e-30b120f9c264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "no. 246",
      "poi_type": "Restaurants",
      "poi_address": "129 E Ponce de Leon Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Locally sourced Italian cuisine is served on the bustling patio or in the sun-filled dining room.",
      "poi_long_description": "Locally sourced Italian cuisine is served on the bustling patio or in the sun-filled dining room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-a2e2-713e-a207-926766b1c4be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-a2e2-713e-a207-926766b1c4be",
        "storage_key": "property/6767906449167646/019fec35-a2e2-713e-a207-926766b1c4be.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.no246.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1551227096867836447",
      "poi_item_slug": "no-246",
      "poi_latitude": "33.7754389",
      "poi_longitude": "-84.29534439999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 678-399-8246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJTey2Fj4H9YgRH5LEatMQhxU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_3a82922b-262d-4ca3-8bb5-40f42019847f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "LEON's Full Service",
      "poi_type": "Restaurants",
      "poi_address": "131 E Ponce de Leon Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Inspired modern eatery in ex gas station offers New American fare & cocktails, plus a bocce court.",
      "poi_long_description": "Inspired modern eatery in ex gas station offers New American fare & cocktails, plus a bocce court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-9fa9-7779-846e-f6f55d6656b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-9fa9-7779-846e-f6f55d6656b6",
        "storage_key": "property/6767906449167646/019fec35-9fa9-7779-846e-f6f55d6656b6.webp",
        "width": 1280,
        "height": 561
      },
      "poi_business_url": "http://leonsfullservice.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10338535237104506206",
      "poi_item_slug": "leons-full-service",
      "poi_latitude": "33.7753818",
      "poi_longitude": "-84.2951157",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-343-0470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKX3oFT4H9YgRXhV5sQXbeY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_fe07cd35-9765-4e92-98d0-9db5e0265346",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Taqueria del Sol",
      "poi_type": "Restaurants",
      "poi_address": "359 W Ponce de Leon Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Local counter-serve chain offering soft tacos & enchiladas in a relaxed space.",
      "poi_long_description": "Local counter-serve chain offering soft tacos & enchiladas in a relaxed space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-a21a-74f1-a010-8f98727d65db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-a21a-74f1-a010-8f98727d65db",
        "storage_key": "property/6767906449167646/019fec35-a21a-74f1-a010-8f98727d65db.webp",
        "width": 1280,
        "height": 773
      },
      "poi_business_url": "http://taqueriadelsol.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=349995822199699778",
      "poi_item_slug": "taqueria-del-sol",
      "poi_latitude": "33.77594630000001",
      "poi_longitude": "-84.3021371",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-377-7668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUCRtiIH9YgRQnkVj1hv2wQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_f16a037a-9ce0-42dd-bca4-32099fa75a77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "The Reading Room",
      "poi_type": "Restaurants",
      "poi_address": "429 Church St, Decatur, GA 30030, USA",
      "poi_short_description": "Cute joint for coffee, beer and cocktails in a relaxed, bookish space.",
      "poi_long_description": "Cute joint for coffee, beer and cocktails in a relaxed, bookish space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-9ef5-7504-99f6-06e16e5de947.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-9ef5-7504-99f6-06e16e5de947",
        "storage_key": "property/6767906449167646/019fec35-9ef5-7504-99f6-06e16e5de947.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://thereadingroomatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3931768662768506781",
      "poi_item_slug": "the-reading-room",
      "poi_latitude": "33.7751436",
      "poi_longitude": "-84.2947751",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-855-5653",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-9f9f-71cf-9b91-a6f04d270421.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec36-9f9f-71cf-9b91-a6f04d270421",
        "storage_key": "property/6767906449167646/019fec36-9f9f-71cf-9b91-a6f04d270421.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJY83ReEwH9YgRnVdUc8RykDY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_1965f7f6-4c24-4125-9048-00b48de42d62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "FolkArt",
      "poi_type": "Restaurants",
      "poi_address": "174 W Ponce de Leon Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Contemporary chain outlet offering comfort food & brunch, plus a take-out option.",
      "poi_long_description": "Contemporary chain outlet offering comfort food & brunch, plus a take-out option.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-a6bc-72af-b408-1841cffe2b29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-a6bc-72af-b408-1841cffe2b29",
        "storage_key": "property/6767906449167646/019fec35-a6bc-72af-b408-1841cffe2b29.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "https://folkartrestaurant.com/folkartrestaurant-decatur",
      "poi_directions_map_url": "https://maps.google.com/?cid=5706395794865049873",
      "poi_item_slug": "folkart",
      "poi_latitude": "33.7754481",
      "poi_longitude": "-84.2980766",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-373-9943",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhX3ADVkH9YgREdG23L0wMU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_396d11a9-c835-4574-8625-32d5385e5ecb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "The Iberian Pig",
      "poi_type": "Restaurants",
      "poi_address": "121 Sycamore St, Decatur, GA 30030, USA",
      "poi_short_description": "Eatery serves all things pig via tapas & entrees, plus cocktails & wine in a modern setting.",
      "poi_long_description": "Eatery serves all things pig via tapas & entrees, plus cocktails & wine in a modern setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-9c91-70dd-9c55-3f29c1138b51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-9c91-70dd-9c55-3f29c1138b51",
        "storage_key": "property/6767906449167646/019fec35-9c91-70dd-9c55-3f29c1138b51.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.iberianpig.com/decatur",
      "poi_directions_map_url": "https://maps.google.com/?cid=13515214754655636829",
      "poi_item_slug": "the-iberian-pig",
      "poi_latitude": "33.7744382",
      "poi_longitude": "-84.2959884",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-371-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV82ucD4H9YgRXQ1ecjawj7s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "spanish_restaurant"
    },
    {
      "id": "custom_bca8a5fe-9bcc-4b62-b44b-772e531baea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Chai Pani Decatur",
      "poi_type": "Restaurants",
      "poi_address": "406 W Ponce de Leon Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Indian street snacks, platters, lassis & draft beers in a casual, colorful space with a hip vibe.",
      "poi_long_description": "Indian street snacks, platters, lassis & draft beers in a casual, colorful space with a hip vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-a7f3-70a3-a105-a20cd3ab5a4c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-a7f3-70a3-a105-a20cd3ab5a4c",
        "storage_key": "property/6767906449167646/019fec35-a7f3-70a3-a105-a20cd3ab5a4c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.chaipani.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13217025167361858883",
      "poi_item_slug": "chai-pani-decatur",
      "poi_latitude": "33.7754109",
      "poi_longitude": "-84.3026472",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-378-4032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc_8ytCIH9YgRQ10A6FxObLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_d4918c32-00cd-4ee8-9547-e92d3589cf16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Melton's App & Tap",
      "poi_type": "Restaurants",
      "poi_address": "2500 N Decatur Rd, Decatur, GA 30033, USA",
      "poi_short_description": "Laid-back watering hole offering a big beer selection & standard pub grub in a no-frills setting.",
      "poi_long_description": "Laid-back watering hole offering a big beer selection & standard pub grub in a no-frills setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-a2cd-727b-b01a-275c02ba2d34.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-a2cd-727b-b01a-275c02ba2d34",
        "storage_key": "property/6767906449167646/019fec35-a2cd-727b-b01a-275c02ba2d34.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.meltonsappandtap.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4184638949418002871",
      "poi_item_slug": "meltons-app--tap",
      "poi_latitude": "33.794096",
      "poi_longitude": "-84.2909525",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-634-9112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-9ff5-769c-b239-24697ad2db11.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec36-9ff5-769c-b239-24697ad2db11",
        "storage_key": "property/6767906449167646/019fec36-9ff5-769c-b239-24697ad2db11.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb7R4rXQH9YgRt-lSDfTSEjo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_a9282542-ca85-400a-9ecc-56d35c20884d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Pastries A Go Go",
      "poi_type": "Restaurants",
      "poi_address": "235 Ponce De Leon Pl, Decatur, GA 30030, USA",
      "poi_short_description": "Cafe & bakery with breakfast & lunch favorites, plus sweet treats including special occasion cakes.",
      "poi_long_description": "Cafe & bakery with breakfast & lunch favorites, plus sweet treats including special occasion cakes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-aceb-731e-9cb1-9cdf5fc5105d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-aceb-731e-9cb1-9cdf5fc5105d",
        "storage_key": "property/6767906449167646/019fec35-aceb-731e-9cb1-9cdf5fc5105d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://pastriesagogo.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15759877485921316504",
      "poi_item_slug": "pastries-a-go-go",
      "poi_latitude": "33.7762043",
      "poi_longitude": "-84.29980690000001",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 470-881-1004",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXaC0bT0H9YgRmC4E9BJVtto",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_b8fa141e-faff-4c01-a1bd-008f16219b8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Sapori di Napoli Pizzeria & Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "314 Church St, Decatur, GA 30030, USA",
      "poi_short_description": "Neapolitan pizzas, pastas, salads & some gluten-free pies in a casual space with a brick oven.",
      "poi_long_description": "Neapolitan pizzas, pastas, salads & some gluten-free pies in a casual space with a brick oven.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-a988-7149-b1cb-2e7d39c94320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-a988-7149-b1cb-2e7d39c94320",
        "storage_key": "property/6767906449167646/019fec35-a988-7149-b1cb-2e7d39c94320.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://saporidinapolipizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9404570652568027332",
      "poi_item_slug": "sapori-di-napoli-pizzeria--restaurant",
      "poi_latitude": "33.7734137",
      "poi_longitude": "-84.2950256",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-371-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSXO9D4H9YgRxIBhUy6_g4I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a9b23695-a5d3-49ab-b46e-2d4e3b314b05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "The White Bull",
      "poi_type": "Restaurants",
      "poi_address": "123 E Court Square, Decatur, GA 30030, USA",
      "poi_short_description": "Thoughtful New American fare featuring seasonal, local ingredients served in a mod-rustic space.",
      "poi_long_description": "Thoughtful New American fare featuring seasonal, local ingredients served in a mod-rustic space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-aa98-757b-811d-184c800859b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-aa98-757b-811d-184c800859b7",
        "storage_key": "property/6767906449167646/019fec35-aa98-757b-811d-184c800859b7.webp",
        "width": 706,
        "height": 1280
      },
      "poi_business_url": "https://whitebullatl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14493081639704217732",
      "poi_item_slug": "the-white-bull",
      "poi_latitude": "33.7750533",
      "poi_longitude": "-84.2958056",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-600-5649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b6-7682-8935-9d7f41f69bf2",
        "storage_key": "property/6767906449167646/019fec32-a3b6-7682-8935-9d7f41f69bf2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPZ3Ccj4H9YgRhEhOs_bEIck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_890f41b1-eb66-46f6-8b10-12318f04d043",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Patel Brothers",
      "poi_type": "Shopping & Retail",
      "poi_address": "1709 Church St F, Decatur, GA 30033, USA",
      "poi_short_description": "This grocery chain sells Indian foods, plus beauty products, spiritual items & more.",
      "poi_long_description": "This grocery chain sells Indian foods, plus beauty products, spiritual items & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-add6-743d-b179-2d78e66a3b24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-add6-743d-b179-2d78e66a3b24",
        "storage_key": "property/6767906449167646/019fec35-add6-743d-b179-2d78e66a3b24.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.patelbros.com/specials/1709-church-street-suite-f-decatur",
      "poi_directions_map_url": "https://maps.google.com/?cid=10467983756410566399",
      "poi_item_slug": "patel-brothers",
      "poi_latitude": "33.797527",
      "poi_longitude": "-84.28097",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-296-2696",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cd-731a-b3a8-eec52490825b",
        "storage_key": "property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4vrxncH9YgR_zZpw8O_RZE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_6c5f48a9-060d-4220-a8e3-9f19c75e3554",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1555 Church St, Decatur, GA 30033, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-bb1c-7231-b299-1c359efc6a79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-bb1c-7231-b299-1c359efc6a79",
        "storage_key": "property/6767906449167646/019fec35-bb1c-7231-b299-1c359efc6a79.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/decatur",
      "poi_directions_map_url": "https://maps.google.com/?cid=1027065595422923488",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "33.792553",
      "poi_longitude": "-84.28428439999999",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 470-237-7340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cd-731a-b3a8-eec52490825b",
        "storage_key": "property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJd_V_rMH9YgR4Fo1qLfeQA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_6f3419df-47d1-47dc-8764-6967a43fde03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "676 Decatur Village Wy, Decatur, GA 30033, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-be38-77ee-b0e8-4ade8cf69953.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-be38-77ee-b0e8-4ade8cf69953",
        "storage_key": "property/6767906449167646/019fec35-be38-77ee-b0e8-4ade8cf69953.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ga/decatur/676-decatur-village-way/l883",
      "poi_directions_map_url": "https://maps.google.com/?cid=16624813509554470067",
      "poi_item_slug": "aldi",
      "poi_latitude": "33.796123",
      "poi_longitude": "-84.285242",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cd-731a-b3a8-eec52490825b",
        "storage_key": "property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUW4cHYH9YgRs_wbDs4zt-Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_bc962875-19c5-42db-98b3-342073a70606",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "2875 N Decatur Rd, Decatur, GA 30033, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-bf60-71ab-a1b6-aea8beadc46e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-bf60-71ab-a1b6-aea8beadc46e",
        "storage_key": "property/6767906449167646/019fec35-bf60-71ab-a1b6-aea8beadc46e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/decatur/north-decatur/011/00459?cid=loc_01100459_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17008825228139202517",
      "poi_item_slug": "kroger",
      "poi_latitude": "33.7917716",
      "poi_longitude": "-84.2734301",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 404-294-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cd-731a-b3a8-eec52490825b",
        "storage_key": "property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdK6x34H9YgR1YfwqW18C-w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0330579f-1c4b-4aa8-83b1-57b30d8e71bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Emory Decatur Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "2701 N Decatur Rd, Decatur, GA 30033, USA",
      "poi_short_description": "Community hospital on North Decatur Road, part of Emory Healthcare, with a 24-hour emergency department.",
      "poi_long_description": "Community hospital on North Decatur Road, part of Emory Healthcare, with a 24-hour emergency department.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-bfca-7037-85a8-99002bb6ef89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-bfca-7037-85a8-99002bb6ef89",
        "storage_key": "property/6767906449167646/019fec35-bfca-7037-85a8-99002bb6ef89.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-decatur-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=2457386696593064527",
      "poi_item_slug": "emory-decatur-hospital",
      "poi_latitude": "33.7907026",
      "poi_longitude": "-84.28197589999999",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-501-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a404-73de-9264-328c613b5b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a404-73de-9264-328c613b5b5b",
        "storage_key": "property/6767906449167646/019fec32-a404-73de-9264-328c613b5b5b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJudei5nAH9YgRT0IzRi5kGiI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_bdd79ca3-a613-432c-b391-c88189e0764e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2551 Blackmon Dr, Decatur, GA 30033, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-cf6b-762d-9239-086707b308df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-cf6b-762d-9239-086707b308df",
        "storage_key": "property/6767906449167646/019fec35-cf6b-762d-9239-086707b308df.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://sprouts.com/store/ga/decatur/decatur",
      "poi_directions_map_url": "https://maps.google.com/?cid=5743251603129224563",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "33.7939004",
      "poi_longitude": "-84.2874588",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 404-965-6290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cd-731a-b3a8-eec52490825b",
        "storage_key": "property/6767906449167646/019fec32-a3cd-731a-b3a8-eec52490825b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJndfyFHQH9YgRc801bOcgtE8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0e398896-cfaa-4fda-a842-92be733c4ec8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Hess Academy",
      "poi_type": "Education",
      "poi_address": "611 Medlock Rd, Decatur, GA 30033, USA",
      "poi_short_description": "Private school on Medlock Road in Decatur.",
      "poi_long_description": "Private school on Medlock Road in Decatur.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-cfb3-7618-9bf0-513812230787.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-cfb3-7618-9bf0-513812230787",
        "storage_key": "property/6767906449167646/019fec35-cfb3-7618-9bf0-513812230787.webp",
        "width": 982,
        "height": 1065
      },
      "poi_business_url": "http://www.hessacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10722862799884226478",
      "poi_item_slug": "hess-academy",
      "poi_latitude": "33.7945423",
      "poi_longitude": "-84.2893934",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 678-308-6380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b8-72bc-82fb-e0a174b2ac10",
        "storage_key": "property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbzp86nQH9YgRro9ZgudCz5Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_29424925-2b2e-47d6-8615-4463d676dfcf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Dreamcatchers Care",
      "poi_type": "Education",
      "poi_address": "1450 Scott Blvd, Decatur, GA 30030, USA",
      "poi_short_description": "Preschool and child-care center on Scott Boulevard.",
      "poi_long_description": "Preschool and child-care center on Scott Boulevard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-e0f1-718b-979a-89daad94ed7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-e0f1-718b-979a-89daad94ed7d",
        "storage_key": "property/6767906449167646/019fec35-e0f1-718b-979a-89daad94ed7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dreamcatcherscare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6046532656772520365",
      "poi_item_slug": "dreamcatchers-care",
      "poi_latitude": "33.7927",
      "poi_longitude": "-84.292131",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-254-4309",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b8-72bc-82fb-e0a174b2ac10",
        "storage_key": "property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTx3gPK8H9YgRrZm5WWqZ6VM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_4512d72b-56f8-42e6-b116-212e2f1bde29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Agnes Scott College",
      "poi_type": "Education",
      "poi_address": "141 E College Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Private liberal-arts women's college in downtown Decatur, founded in 1889.",
      "poi_long_description": "Private liberal-arts women's college in downtown Decatur, founded in 1889.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-e161-70ed-bd22-5c1236ff2f66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-e161-70ed-bd22-5c1236ff2f66",
        "storage_key": "property/6767906449167646/019fec35-e161-70ed-bd22-5c1236ff2f66.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.agnesscott.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15192735507587931521",
      "poi_item_slug": "agnes-scott-college",
      "poi_latitude": "33.7685056",
      "poi_longitude": "-84.29453459999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-471-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b8-72bc-82fb-e0a174b2ac10",
        "storage_key": "property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO_V-rDkH9YgRgR0-GHNw19I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1b8be84b-17c4-4e4c-8df1-366e17de858b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Saint Thomas More Catholic School",
      "poi_type": "Education",
      "poi_address": "630 W Ponce de Leon Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Private Catholic school for elementary and middle grades on West Ponce de Leon Avenue.",
      "poi_long_description": "Private Catholic school for elementary and middle grades on West Ponce de Leon Avenue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-eef0-7771-aa74-ad9d48b8f43c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-eef0-7771-aa74-ad9d48b8f43c",
        "storage_key": "property/6767906449167646/019fec35-eef0-7771-aa74-ad9d48b8f43c.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.stmga.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3227733590369216558",
      "poi_item_slug": "saint-thomas-more-catholic-school",
      "poi_latitude": "33.7732196",
      "poi_longitude": "-84.3054971",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-373-8456",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b8-72bc-82fb-e0a174b2ac10",
        "storage_key": "property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf1dB2yMH9YgRLqiNY5k2yyw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_13d12de3-8b7d-42f4-9827-48d38b0f87f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Eddie's Attic",
      "poi_type": "Entertainment",
      "poi_address": "515 N McDonough St, Decatur, GA 30030, USA",
      "poi_short_description": "Venue features an intimate stage for acoustic singer-songwriters plus a poolroom & covered patio.",
      "poi_long_description": "Venue features an intimate stage for acoustic singer-songwriters plus a poolroom & covered patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-ebed-7455-abd6-351edc268969.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-ebed-7455-abd6-351edc268969",
        "storage_key": "property/6767906449167646/019fec35-ebed-7455-abd6-351edc268969.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.eddiesattic.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15679430057188119717",
      "poi_item_slug": "eddies-attic",
      "poi_latitude": "33.7739746",
      "poi_longitude": "-84.2962715",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-377-4976",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-6m1T0H9YgRpdRHV5CGmNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_00c617e8-1c16-4663-a07b-4ef3248409c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Avon Theater",
      "poi_type": "Entertainment",
      "poi_address": "106 N Avondale Rd, Avondale Estates, GA 30002, USA",
      "poi_short_description": "Relaxed bar-equipped venue featuring 2 floors and a balcony, plus live music and a stage.",
      "poi_long_description": "Relaxed bar-equipped venue featuring 2 floors and a balcony, plus live music and a stage.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-f33d-771c-a090-cb8cc7a0fe24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-f33d-771c-a090-cb8cc7a0fe24",
        "storage_key": "property/6767906449167646/019fec35-f33d-771c-a090-cb8cc7a0fe24.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.avon-theater.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17476516327773511104",
      "poi_item_slug": "avon-theater",
      "poi_latitude": "33.7763378",
      "poi_longitude": "-84.2681939",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-274-3196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLcl6yN-p9YgRwB1BbAEPifI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_1e68b4ae-65fa-4bb4-809a-b3269d15b79e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Variety Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "1099 Euclid Ave NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_long_description": "Converted movie theater now serves as an intimate concert hall featuring a variety of popular acts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec35-f415-750f-a2c6-7b75b7fd2752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec35-f415-750f-a2c6-7b75b7fd2752",
        "storage_key": "property/6767906449167646/019fec35-f415-750f-a2c6-7b75b7fd2752.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://www.variety-playhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14554971689164868841",
      "poi_item_slug": "variety-playhouse",
      "poi_latitude": "33.76372870000001",
      "poi_longitude": "-84.35107149999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-524-7354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8d2cqkG9YgR6QyKwKKl_ck",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_648d2b0e-62b0-45ba-b410-c81506609ac8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Fernbank Museum | 3D Theater | Forest",
      "poi_type": "Entertainment",
      "poi_address": "767 Clifton Rd NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Natural sciences museum with a 3-story, sky-lit Great Hall & skeletons of dinosaurs.",
      "poi_long_description": "Natural sciences museum with a 3-story, sky-lit Great Hall & skeletons of dinosaurs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-7e27-70df-89d2-e6be57f72d24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-7e27-70df-89d2-e6be57f72d24",
        "storage_key": "property/6767906449167646/019fec32-7e27-70df-89d2-e6be57f72d24.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.fernbankmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16009008757691675296",
      "poi_item_slug": "fernbank-museum--3d-theater--forest",
      "poi_latitude": "33.7739247",
      "poi_longitude": "-84.32799849999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-929-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cb-7008-b84a-45f479c794fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cb-7008-b84a-45f479c794fd",
        "storage_key": "property/6767906449167646/019fec32-a3cb-7008-b84a-45f479c794fd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQTC3DsEG9YgRoHJUUKVsK94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_7975f95d-81e2-4d9d-9bba-919fe7465529",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Michael C. Carlos Museum",
      "poi_type": "Entertainment",
      "poi_address": "571 South Kilgo Cir NE 3rd floor, Atlanta, GA 30322, USA",
      "poi_short_description": "Museum of ancient art featuring Greek & Roman collections & an Egyptian exhibit including mummies.",
      "poi_long_description": "Museum of ancient art featuring Greek & Roman collections & an Egyptian exhibit including mummies.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-1363-70c9-a528-c858530dfc28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-1363-70c9-a528-c858530dfc28",
        "storage_key": "property/6767906449167646/019fec36-1363-70c9-a528-c858530dfc28.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "http://www.carlos.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16257075899105576788",
      "poi_item_slug": "michael-c-carlos-museum",
      "poi_latitude": "33.79034499999999",
      "poi_longitude": "-84.3243433",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-727-4282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cb-7008-b84a-45f479c794fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cb-7008-b84a-45f479c794fd",
        "storage_key": "property/6767906449167646/019fec32-a3cb-7008-b84a-45f479c794fd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8bYMPAG9YgRVIfAhGW8nOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_00baebe1-7843-459f-80f4-553c7877466c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Plaza Theatre",
      "poi_type": "Entertainment",
      "poi_address": "1049 Ponce De Leon Ave NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_long_description": "Independent movie theater showcases cult classics & midnight movies on Friday on the silver screen.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-17b2-7178-ae91-a2ee7c99cfc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-17b2-7178-ae91-a2ee7c99cfc2",
        "storage_key": "property/6767906449167646/019fec36-17b2-7178-ae91-a2ee7c99cfc2.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.plazaatlanta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5819026170921268730",
      "poi_item_slug": "plaza-theatre",
      "poi_latitude": "33.7734567",
      "poi_longitude": "-84.3530406",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 470-410-1939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-a0b0-707b-b555-acdb57f45a22.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec36-a0b0-707b-b555-acdb57f45a22",
        "storage_key": "property/6767906449167646/019fec36-a0b0-707b-b555-acdb57f45a22.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJP47X-6MG9YgR-rV20HhVwVA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_20025f6c-3305-4a4b-8111-c6acf26c00d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Callanwolde Fine Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "980 Briarcliff Rd NE, Atlanta, GA 30306, USA",
      "poi_short_description": "Community arts center in a mansion, with exhibits, concerts & workshops, plus outreach programs.",
      "poi_long_description": "Community arts center in a mansion, with exhibits, concerts & workshops, plus outreach programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-3a5c-73e1-8742-a7b660252b3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-3a5c-73e1-8742-a7b660252b3d",
        "storage_key": "property/6767906449167646/019fec36-3a5c-73e1-8742-a7b660252b3d.webp",
        "width": 1280,
        "height": 726
      },
      "poi_business_url": "http://www.callanwolde.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11724207488683623847",
      "poi_item_slug": "callanwolde-fine-arts-center",
      "poi_latitude": "33.7818415",
      "poi_longitude": "-84.345085",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 404-872-5338",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgSoFrpkG9YgRp0X265fAtKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b77ee7ae-5850-4209-b60e-4f8ddd6c8148",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Piedmont Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2520 N Decatur Rd, Decatur, GA 30033, USA",
      "poi_short_description": "Walk-in urgent care clinic on North Decatur Road, part of the Piedmont Healthcare network.",
      "poi_long_description": "Walk-in urgent care clinic on North Decatur Road, part of the Piedmont Healthcare network.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-19f2-73ab-acaf-08cb4f377279.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-19f2-73ab-acaf-08cb4f377279",
        "storage_key": "property/6767906449167646/019fec36-19f2-73ab-acaf-08cb4f377279.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.piedmonturgentcare.org/locations/decatur-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=10990674665409962150",
      "poi_item_slug": "piedmont-urgent-care",
      "poi_latitude": "33.7940978",
      "poi_longitude": "-84.2905207",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 678-685-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAS0_yaEH9YgRpmCliWC4hpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_3f863e32-e797-4964-bdae-be8f3c1d085c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Emory at Decatur - Primary Care Scott Boulevard",
      "poi_type": "Health and Wellness",
      "poi_address": "1418 Scott Blvd, Decatur, GA 30030, USA",
      "poi_short_description": "Emory Healthcare primary-care practice on Scott Boulevard.",
      "poi_long_description": "Emory Healthcare primary-care practice on Scott Boulevard.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-260a-700c-b9be-ef24b30b66d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-260a-700c-b9be-ef24b30b66d8",
        "storage_key": "property/6767906449167646/019fec36-260a-700c-b9be-ef24b30b66d8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/primary-care/emory-at-decatur-primary-care-scott-blvd",
      "poi_directions_map_url": "https://maps.google.com/?cid=15506558049775584311",
      "poi_item_slug": "emory-at-decatur---primary-care-scott-boulevard",
      "poi_latitude": "33.7922677",
      "poi_longitude": "-84.2928548",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 404-446-1340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ49hkAwH9YgRNwTZlWNcMtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f79cf62b-4f08-41b0-9c64-08a85ac9ba80",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Health and Wellness",
      "poi_address": "2738 N Decatur Rd, Decatur, GA 30033, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-223e-7211-8bfa-7551d36b05be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-223e-7211-8bfa-7551d36b05be",
        "storage_key": "property/6767906449167646/019fec36-223e-7211-8bfa-7551d36b05be.webp",
        "width": 936,
        "height": 800
      },
      "poi_business_url": "https://www.cvs.com/store-locator/decatur-ga-pharmacies/2738-n-decatur-rd-decatur-ga-30033/storeid=2175?WT.mc_id=LS_GOOGLE_FS_2175",
      "poi_directions_map_url": "https://maps.google.com/?cid=12094567176043358697",
      "poi_item_slug": "cvs",
      "poi_latitude": "33.7931986",
      "poi_longitude": "-84.2813153",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-508-8058",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZTxAT3cH9YgR6ekpUMSI2Kc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_cb2460c4-23fe-4cf8-8d8a-346c36094140",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1496 Church St, Decatur, GA 30030, USA",
      "poi_short_description": "Chain health club with a pool, basketball court, and state-of-the-art equipment in the Suburban Plaza Shopping Center.",
      "poi_long_description": "Chain health club with a pool, basketball court, and state-of-the-art equipment in the Suburban Plaza Shopping Center.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-89ce-7506-b109-ddb3ad5cddc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-89ce-7506-b109-ddb3ad5cddc7",
        "storage_key": "property/6767906449167646/019fec32-89ce-7506-b109-ddb3ad5cddc7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=11421284060159847368",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "33.7915115",
      "poi_longitude": "-84.2866363",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-267-2723",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxbC63MH9YgRyKuoFFeNgJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c783300a-f550-41de-b223-611c78ed1164",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Woodlands Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "932 Scott Blvd, Decatur, GA 30030, USA",
      "poi_short_description": "This 7-acre urban green space offers self-guided tours, walking trails & gardens with native plants.",
      "poi_long_description": "This 7-acre urban green space offers self-guided tours, walking trails & gardens with native plants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-4114-754d-8ff3-08f413d222fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-4114-754d-8ff3-08f413d222fc",
        "storage_key": "property/6767906449167646/019fec36-4114-754d-8ff3-08f413d222fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.woodlandsgarden.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14370086695945779097",
      "poi_item_slug": "woodlands-garden",
      "poi_latitude": "33.786119",
      "poi_longitude": "-84.3036992",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 404-373-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9xfw5BoH9YgRmTdqx7bNbMc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "garden"
    },
    {
      "id": "custom_4267fd62-280f-4c1f-8614-46535c532f86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Glenlake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1121 Church St, Decatur, GA 30030, USA",
      "poi_short_description": "Large city park offering tennis, basketball & volleyball courts, ball fields, a pool & picnic areas.",
      "poi_long_description": "Large city park offering tennis, basketball & volleyball courts, ball fields, a pool & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-36ed-76eb-833a-1e6b0dde55e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-36ed-76eb-833a-1e6b0dde55e3",
        "storage_key": "property/6767906449167646/019fec36-36ed-76eb-833a-1e6b0dde55e3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15499879946126314614",
      "poi_item_slug": "glenlake-park",
      "poi_latitude": "33.7838118",
      "poi_longitude": "-84.2929793",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-377-7231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a405-770d-b8d2-a43cf9229a21",
        "storage_key": "property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJeS-7LxMH9YgRdkwParCiGtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_53a7b209-0901-46f8-a628-d3cd0c4670fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Scott Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "231 Sycamore St, Decatur, GA 30030, USA",
      "poi_short_description": "This 4-acre site at Decatur Recreation Center is surrounded by gardens & features 2 tennis courts.",
      "poi_long_description": "This 4-acre site at Decatur Recreation Center is surrounded by gardens & features 2 tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-44e3-72cb-845b-7ea786e1b2a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-44e3-72cb-845b-7ea786e1b2a2",
        "storage_key": "property/6767906449167646/019fec36-44e3-72cb-845b-7ea786e1b2a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=16355166589652909972",
      "poi_item_slug": "scott-park",
      "poi_latitude": "33.7730308",
      "poi_longitude": "-84.2934609",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-377-0494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a405-770d-b8d2-a43cf9229a21",
        "storage_key": "property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0Xo-Az8H9YgRlD-ZIlw5-eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2c7385e9-911b-42c3-9a32-51a0415688a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Oakhurst Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "414 East Lake Dr, Decatur, GA 30030, USA",
      "poi_short_description": "Spacious park, with a pool, for dogs to romp, plus trails for walking dogs.",
      "poi_long_description": "Spacious park, with a pool, for dogs to romp, plus trails for walking dogs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-3ad9-726a-998b-ebc0bef84a1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-3ad9-726a-998b-ebc0bef84a1b",
        "storage_key": "property/6767906449167646/019fec36-3ad9-726a-998b-ebc0bef84a1b.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://oakhurstdogpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=507980101239836156",
      "poi_item_slug": "oakhurst-dog-park",
      "poi_latitude": "33.76",
      "poi_longitude": "-84.3097222",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-377-7231",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a405-770d-b8d2-a43cf9229a21",
        "storage_key": "property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJV5cwLCoH9YgR_A1e7zW1DAc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_b0fb3abe-3d76-4904-a796-8462479252a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Decatur Legacy Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "500 S Columbia Dr, Decatur, GA 30030, USA",
      "poi_short_description": "Green space featuring trails, picnic areas, a playground, a community garden, and a pond.",
      "poi_long_description": "Green space featuring trails, picnic areas, a playground, a community garden, and a pond.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-58cc-76b9-9899-82ef3f3616f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-58cc-76b9-9899-82ef3f3616f0",
        "storage_key": "property/6767906449167646/019fec36-58cc-76b9-9899-82ef3f3616f0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://decaturlegacypark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9412525789555989252",
      "poi_item_slug": "decatur-legacy-park",
      "poi_latitude": "33.7668742",
      "poi_longitude": "-84.28101029999999",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a405-770d-b8d2-a43cf9229a21",
        "storage_key": "property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkQI3LkUH9YgRBBuw_VUCoII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_99ee6af8-c0e0-4479-a0e3-b534fa11e7a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Mason Mill Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1406-1458 McConnell Dr, Decatur, GA 30033, USA",
      "poi_short_description": "Relaxed park featuring tennis courts, a playground and walking trails.",
      "poi_long_description": "Relaxed park featuring tennis courts, a playground and walking trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-91c6-75fe-961e-a5d63998eb72.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-91c6-75fe-961e-a5d63998eb72",
        "storage_key": "property/6767906449167646/019fec32-91c6-75fe-961e-a5d63998eb72.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dekalbcountyga.gov/parks/mason-mill-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527184594859608601",
      "poi_item_slug": "mason-mill-park",
      "poi_latitude": "33.8072089",
      "poi_longitude": "-84.30629019999999",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-371-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a405-770d-b8d2-a43cf9229a21",
        "storage_key": "property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJidPBha4H9YgRGUpmH4LudWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2d07dc36-165b-497f-9e4c-de82881f0e41",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Decatur MARTA Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "400 Church St, Decatur, GA 30030, USA",
      "poi_short_description": "MARTA Blue Line rail station beneath the Decatur Square on Church Street.",
      "poi_long_description": "MARTA Blue Line rail station beneath the Decatur Square on Church Street.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-9529-71e8-976b-0df320e0d92e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-9529-71e8-976b-0df320e0d92e",
        "storage_key": "property/6767906449167646/019fec32-9529-71e8-976b-0df320e0d92e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://itsmarta.com/Decatur.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=15059208201341932847",
      "poi_item_slug": "decatur",
      "poi_latitude": "33.77468",
      "poi_longitude": "-84.29553",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3ca-7079-ad63-7ea51c2bb79f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3ca-7079-ad63-7ea51c2bb79f",
        "storage_key": "property/6767906449167646/019fec32-a3ca-7079-ad63-7ea51c2bb79f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJRZAUaT4H9YgRL5WibxIO_dA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_4c1604f5-bc09-4bbe-9d22-1a12e8120ce0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Avondale MARTA Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "915 E Ponce de Leon Ave, Decatur, GA 30030, USA",
      "poi_short_description": "MARTA Blue Line rail station on East Ponce de Leon Avenue, with a park-and-ride lot.",
      "poi_long_description": "MARTA Blue Line rail station on East Ponce de Leon Avenue, with a park-and-ride lot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-6ff2-75a4-84b4-29f201e4c4f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-6ff2-75a4-84b4-29f201e4c4f5",
        "storage_key": "property/6767906449167646/019fec36-6ff2-75a4-84b4-29f201e4c4f5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://itsmarta.com/Avondale.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=4423225190850044843",
      "poi_item_slug": "avondale",
      "poi_latitude": "33.77535",
      "poi_longitude": "-84.28191",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-848-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3ca-7079-ad63-7ea51c2bb79f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3ca-7079-ad63-7ea51c2bb79f",
        "storage_key": "property/6767906449167646/019fec32-a3ca-7079-ad63-7ea51c2bb79f.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_e1VrEIH9YgRqyMtNuBzYj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "subway_station"
    },
    {
      "id": "custom_8e3afc37-5157-4360-9e78-2e6a3d2cc8ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Hartsfield-Jackson Atlanta International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6000 N Terminal Pkwy Ste 4000, Atlanta, GA 30320, USA",
      "poi_short_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_long_description": "This hub featuring 250+ pieces of art & occasional live music is one of the busiest in the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-6ed1-759e-a559-0521fb3014f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-6ed1-759e-a559-0521fb3014f6",
        "storage_key": "property/6767906449167646/019fec36-6ed1-759e-a559-0521fb3014f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690397784234438728",
      "poi_item_slug": "hartsfield-jackson-atlanta-international-airport",
      "poi_latitude": "33.6324187",
      "poi_longitude": "-84.4333116",
      "poi_miles_from_property": "19.6 mi",
      "poi_walking_minutes": "7 hours 20 mins",
      "poi_biking_minutes": "2 hours 8 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 800-897-1910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b5-7142-842d-ab04c921135e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b5-7142-842d-ab04c921135e",
        "storage_key": "property/6767906449167646/019fec32-a3b5-7142-842d-ab04c921135e.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJAVkD4S_99IgRSLCSGO-jF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_8e33eba0-115c-4ffa-957e-112aecc08188",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Emory University",
      "poi_type": "Education",
      "poi_address": "201 Dowman Dr, Atlanta, GA 30322, USA",
      "poi_short_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_long_description": "Research-geared private school founded in 1836 & renowned for its healthcare program.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-751d-72d8-af96-7edb8ae0f398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-751d-72d8-af96-7edb8ae0f398",
        "storage_key": "property/6767906449167646/019fec32-751d-72d8-af96-7edb8ae0f398.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.emory.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6401157007639682133",
      "poi_item_slug": "emory-university",
      "poi_latitude": "33.7973735",
      "poi_longitude": "-84.3252791",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 404-727-6123",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b8-72bc-82fb-e0a174b2ac10",
        "storage_key": "property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJHU-KgPcG9YgRVZzdN2J61Vg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_2a7f4149-4388-4842-9bc3-0bb40414d99e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Centers for Disease Control and Prevention",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 Clifton Rd NE, Atlanta, GA 30333, USA",
      "poi_short_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_long_description": "This federal facility for the prevention & spread of diseases offers exhibits at its nearby museum.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-75cb-753d-809f-2d8e77a8e868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-75cb-753d-809f-2d8e77a8e868",
        "storage_key": "property/6767906449167646/019fec36-75cb-753d-809f-2d8e77a8e868.webp",
        "width": 971,
        "height": 1280
      },
      "poi_business_url": "https://www.cdc.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1310566027616466354",
      "poi_item_slug": "centers-for-disease-control-and-prevention",
      "poi_latitude": "33.799329",
      "poi_longitude": "-84.32858999999999",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 404-639-3311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-a12f-701f-b25c-d932c1ecf602.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec36-a12f-701f-b25c-d932c1ecf602",
        "storage_key": "property/6767906449167646/019fec36-a12f-701f-b25c-d932c1ecf602.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsx8GO3oE9YgRsjXGwtsQMBI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_63f3f611-8efa-4818-ac69-0d0e56d4a94b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "DeKalb County Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "556 N McDonough St, Decatur, GA 30030, USA",
      "poi_short_description": "DeKalb County courthouse on the Decatur Square, home to the county's State and Superior Courts.",
      "poi_long_description": "DeKalb County courthouse on the Decatur Square, home to the county's State and Superior Courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-8233-7379-b241-ad368135971a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-8233-7379-b241-ad368135971a",
        "storage_key": "property/6767906449167646/019fec36-8233-7379-b241-ad368135971a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://dekalbstatecourt.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7496345225696290990",
      "poi_item_slug": "dekalb-county-courthouse",
      "poi_latitude": "33.7740909",
      "poi_longitude": "-84.2971029",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 404-371-2261",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-a12f-701f-b25c-d932c1ecf602.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec36-a12f-701f-b25c-d932c1ecf602",
        "storage_key": "property/6767906449167646/019fec36-a12f-701f-b25c-d932c1ecf602.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD2PF1j0H9YgRrqhS80NeCGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_99c3cee4-7eea-4993-85ce-ff2ee4d3be45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Decatur City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "509 N McDonough St, Decatur, GA 30030, USA",
      "poi_short_description": "City of Decatur municipal offices on North McDonough Street at the Decatur Square.",
      "poi_long_description": "City of Decatur municipal offices on North McDonough Street at the Decatur Square.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-80c4-742d-9607-807e4b2406a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec36-80c4-742d-9607-807e4b2406a6",
        "storage_key": "property/6767906449167646/019fec36-80c4-742d-9607-807e4b2406a6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.decaturga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16343382581441581097",
      "poi_item_slug": "decatur-city-hall",
      "poi_latitude": "33.7737651",
      "poi_longitude": "-84.29635460000002",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 404-370-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec36-a12f-701f-b25c-d932c1ecf602.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec36-a12f-701f-b25c-d932c1ecf602",
        "storage_key": "property/6767906449167646/019fec36-a12f-701f-b25c-d932c1ecf602.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_S6YgD4H9YgRKdAh691bz-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_a4c9db06-8f4f-4876-9e3f-8a2a92fc2471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Ponce City Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "675 Ponce De Leon Ave NE, Atlanta, GA 30308, USA",
      "poi_short_description": "Vibrant converted historic Sears building, now a market with a food hall, shops & living space.",
      "poi_long_description": "People say this market offers a wide variety of food options, including diverse international cuisines, and features unique shops. Visitors also highlight the vibrant and lively atmosphere, making it a great place to hang out. They also appreciate the convenient access to the BeltLine and the fun rooftop activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-6d50-755e-821f-2eb2553ae228.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-6d50-755e-821f-2eb2553ae228",
        "storage_key": "property/6767906449167646/019fec32-6d50-755e-821f-2eb2553ae228.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://poncecitymarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460613837555701121",
      "poi_item_slug": "ponce-city-market",
      "poi_latitude": "33.7727683",
      "poi_longitude": "-84.3655967",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-900-7900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b5-7142-842d-ad257e9238dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b5-7142-842d-ad257e9238dc",
        "storage_key": "property/6767906449167646/019fec32-a3b5-7142-842d-ad257e9238dc.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTTv9ohAE9YgRgRWbbatrrsg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_acd7ec35-827b-4c7d-98e3-bd94ddd74eab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Georgia State University Perimeter College - Clarkston Campus",
      "poi_type": "Education",
      "poi_address": "555 N Indian Creek Dr, Clarkston, GA 30021, USA",
      "poi_short_description": "Georgia State University's two-year associate-degree campus in Clarkston.",
      "poi_long_description": "Georgia State University's two-year associate-degree campus in Clarkston.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-7dd5-726a-baa1-93dea33f917c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-7dd5-726a-baa1-93dea33f917c",
        "storage_key": "property/6767906449167646/019fec32-7dd5-726a-baa1-93dea33f917c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://perimeter.gsu.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13660332733025717079",
      "poi_item_slug": "georgia-state-university-perimeter-college---clarkston-campus",
      "poi_latitude": "33.792329",
      "poi_longitude": "-84.2341775",
      "poi_miles_from_property": "3.7 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 678-891-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3b8-72bc-82fb-e0a174b2ac10",
        "storage_key": "property/6767906449167646/019fec32-a3b8-72bc-82fb-e0a174b2ac10.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf7FRe66p9YgRV4ujwT5Ak70",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_a047a69a-0ce8-4155-9069-a169d4e2cd1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Jimmy Carter Presidential Library and Museum",
      "poi_type": "Entertainment",
      "poi_address": "441 John Lewis Freedom Pkwy NE, Atlanta, GA 30307, USA",
      "poi_short_description": "Housing documents of the 39th president, this museum also features a replica of the Oval Office.",
      "poi_long_description": "Visitors say this presidential library and museum offers informative and interactive exhibits detailing Jimmy Carter's life, presidency, and humanitarian work, including a full-scale replica of the Oval Office. They also highlight the beautiful, peaceful, and well-maintained grounds and gardens, which are ideal for strolling. Guests mention the friendly and knowledgeable staff, free parking, and affordable admission fees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-7e95-765e-a53f-989e758344e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-7e95-765e-a53f-989e758344e2",
        "storage_key": "property/6767906449167646/019fec32-7e95-765e-a53f-989e758344e2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.jimmycarterlibrary.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18446384095411050783",
      "poi_item_slug": "jimmy-carter-presidential-library-and-museum",
      "poi_latitude": "33.7663441",
      "poi_longitude": "-84.35625879999999",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 404-865-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3cb-7008-b84a-45f479c794fd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3cb-7008-b84a-45f479c794fd",
        "storage_key": "property/6767906449167646/019fec32-a3cb-7008-b84a-45f479c794fd.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0vJlwIE9YgRHxlkBZq4_v8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_5e628ca5-eea3-43c9-bc5d-2f48be38f689",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Decatur Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "1100 Clairemont Ave, Decatur, GA 30030, USA",
      "poi_short_description": "Community-focused chain gym featuring basketball and swimming, and classes.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained and frequently upgraded equipment, including numerous weight machines, and a clean steam room. They also highlight the friendly, welcoming, and helpful staff, who are knowledgeable about equipment operation. Visitors appreciate the community-oriented atmosphere, diverse class options, and ample parking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-877c-7229-8ad3-a4b9282b2905.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-877c-7229-8ad3-a4b9282b2905",
        "storage_key": "property/6767906449167646/019fec32-877c-7229-8ad3-a4b9282b2905.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://ymcaatlanta.org/locations/decatur-family-ymca",
      "poi_directions_map_url": "https://maps.google.com/?cid=3935805924555925782",
      "poi_item_slug": "decatur-family-ymca",
      "poi_latitude": "33.7873831",
      "poi_longitude": "-84.3074132",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 404-377-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOXt3uxwH9YgRFqkItqLKnjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ad5cdd33-e335-4476-addb-80f9a3b5fb00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Emory University Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1364 Clifton Rd NE, Atlanta, GA 30322, USA",
      "poi_short_description": "Academic medical center on the Emory University campus on Clifton Road, part of Emory Healthcare.",
      "poi_long_description": "Academic medical center on the Emory University campus on Clifton Road, part of Emory Healthcare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-8922-743a-aac1-a38b71fc105c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-8922-743a-aac1-a38b71fc105c",
        "storage_key": "property/6767906449167646/019fec32-8922-743a-aac1-a38b71fc105c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.emoryhealthcare.org/locations/hospitals/emory-university-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=5349286101784653886",
      "poi_item_slug": "emory-university-hospital",
      "poi_latitude": "33.7917965",
      "poi_longitude": "-84.3197392",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-712-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a404-73de-9264-328c613b5b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a404-73de-9264-328c613b5b5b",
        "storage_key": "property/6767906449167646/019fec32-a404-73de-9264-328c613b5b5b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJyYqdV_oG9YgRPvDOKl57PEo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7e0a9b8e-5eae-48fd-8f60-e380c795a9b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Arthur M. Blank Hospital - Children's Healthcare of Atlanta",
      "poi_type": "Health and Wellness",
      "poi_address": "2220 N Druid Hills Rd NE, Atlanta, GA 30329, USA",
      "poi_short_description": "Children's Healthcare of Atlanta's pediatric hospital on North Druid Hills Road.",
      "poi_long_description": "Children's Healthcare of Atlanta's pediatric hospital on North Druid Hills Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-8dc0-77ae-aa95-d0d012d44197.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-8dc0-77ae-aa95-d0d012d44197",
        "storage_key": "property/6767906449167646/019fec32-8dc0-77ae-aa95-d0d012d44197.webp",
        "width": 774,
        "height": 1280
      },
      "poi_business_url": "https://www.choa.org/locations/arthur-m-blank-hospital?cid=na1_ch-Yx_na3_na4_d-yxll_na6",
      "poi_directions_map_url": "https://maps.google.com/?cid=8182934090098922085",
      "poi_item_slug": "arthur-m-blank-hospital-main-entrance---childrens-healthcare-of-atlanta",
      "poi_latitude": "33.8308023",
      "poi_longitude": "-84.3308112",
      "poi_miles_from_property": "5.1 mi",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 404-785-5437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a404-73de-9264-328c613b5b5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a404-73de-9264-328c613b5b5b",
        "storage_key": "property/6767906449167646/019fec32-a404-73de-9264-328c613b5b5b.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLZXySVMH9YgRZdLHLDOfj3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a4a90c66-5c66-4d33-805c-03930a6ba054",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Atlanta Botanical Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1345 Piedmont Ave NE, Atlanta, GA 30309, USA",
      "poi_short_description": "30-acre garden with a conservatory & fountains playing host to concerts, cocktail parties & more.",
      "poi_long_description": "Visitors say this botanical garden features stunning, well-maintained grounds with diverse plant collections, including impressive orchid displays and seasonal exhibits like the popular holiday lights. They also highlight the peaceful atmosphere, friendly staff, and convenient on-site parking. Many mention the Canopy Walk and themed displays as unique and memorable experiences.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-89d8-769e-86c6-125aeb9e5295.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-89d8-769e-86c6-125aeb9e5295",
        "storage_key": "property/6767906449167646/019fec32-89d8-769e-86c6-125aeb9e5295.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.atlantabg.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11595354526965683893",
      "poi_item_slug": "atlanta-botanical-garden",
      "poi_latitude": "33.7899568",
      "poi_longitude": "-84.37259879999999",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 404-876-5859",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RXVJTgE9YgRtdaB6IH56qA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_6f42392d-8757-4c73-8b13-69fa04c84e36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Piedmont Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Atlanta, GA 30309, USA",
      "poi_short_description": "Sprawling park featuring jogging paths, basketball courts, dog parks, a farmers' market & more.",
      "poi_long_description": "People say this park offers stunning views of the city skyline, well-maintained walking and biking trails, and a wide variety of amenities including sports fields, playgrounds, and a dog park. Visitors also highlight the clean and spacious environment, making it ideal for relaxation, exercise, and family outings. They also appreciate the vibrant atmosphere, especially during the numerous festivals and events hosted there.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-87e9-760c-9e1a-2e570de1820a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-87e9-760c-9e1a-2e570de1820a",
        "storage_key": "property/6767906449167646/019fec32-87e9-760c-9e1a-2e570de1820a.webp",
        "width": 736,
        "height": 485
      },
      "poi_business_url": "https://piedmontpark.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17559229622006002958",
      "poi_item_slug": "piedmont-park",
      "poi_latitude": "33.7879265",
      "poi_longitude": "-84.37216819999999",
      "poi_miles_from_property": "6.0 mi",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 404-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a405-770d-b8d2-a43cf9229a21",
        "storage_key": "property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGaxkUDkE9YgRDjUv9U7qrvM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c9cfe067-b74e-41ef-9e82-6d69ae637c49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Decatur Square",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "509 N McDonough St, Decatur, GA 30030, USA",
      "poi_short_description": "Central square featuring a fountain, shops, restaurants and eateries (many with patios) plus an ice-cream parlor.",
      "poi_long_description": "People say this destination offers a wide variety of restaurants, shops, and boutiques, along with amenities like real bathrooms and a play area for kids. They also highlight the lively atmosphere, especially during events with large screens and live music. Visitors appreciate the area's walkability and convenient access via MARTA.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-8e8f-75d3-9fb2-031bc6d54cbd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-8e8f-75d3-9fb2-031bc6d54cbd",
        "storage_key": "property/6767906449167646/019fec32-8e8f-75d3-9fb2-031bc6d54cbd.webp",
        "width": 562,
        "height": 373
      },
      "poi_business_url": "http://www.decaturga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852833049857969881",
      "poi_item_slug": "decatur-square",
      "poi_latitude": "33.7747076",
      "poi_longitude": "-84.29612030000001",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 404-370-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a405-770d-b8d2-a43cf9229a21",
        "storage_key": "property/6767906449167646/019fec32-a405-770d-b8d2-a43cf9229a21.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZZoD2T0H9YgR2U5zMqZwOVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_aeb091f5-7f31-45fc-a642-fa705af0d73b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Salesforce Tower",
      "poi_type": "Major Employers & Offices",
      "poi_address": "950 East Paces Ferry Rd NE #2800, Atlanta, GA 30326, USA",
      "poi_short_description": "Salesforce's Atlanta office tower in Buckhead on East Paces Ferry Road.",
      "poi_long_description": "Salesforce's Atlanta office tower in Buckhead on East Paces Ferry Road.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-99e2-7070-ad91-1caebeb3c35d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-99e2-7070-ad91-1caebeb3c35d",
        "storage_key": "property/6767906449167646/019fec32-99e2-7070-ad91-1caebeb3c35d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.salesforcetoweratl.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18029887005902748475",
      "poi_item_slug": "salesforce-tower",
      "poi_latitude": "33.84691230000001",
      "poi_longitude": "-84.35721579999999",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 404-492-6845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYQQg1UP9YgRO7tDl7QGN_o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3f2c0e9f-47be-4cbc-bbe7-f64286be1622",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "poi_name": "Google Atlanta",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1105 W Peachtree St NW, Atlanta, GA 30309, USA",
      "poi_short_description": "Google's Atlanta office in Midtown on West Peachtree Street.",
      "poi_long_description": "Google's Atlanta office in Midtown on West Peachtree Street.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-9777-719e-bbbb-e23839b9e13b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fec32-9777-719e-bbbb-e23839b9e13b",
        "storage_key": "property/6767906449167646/019fec32-9777-719e-bbbb-e23839b9e13b.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://about.google/company-info/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5980383670424190234",
      "poi_item_slug": "google-atlanta",
      "poi_latitude": "33.7849821",
      "poi_longitude": "-84.3874302",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 404-939-2356",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fec32-a3bf-76ea-a923-651a7e6e95a3",
        "storage_key": "property/6767906449167646/019fec32-a3bf-76ea-a923-651a7e6e95a3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB9X6DTUF9YgRGj0uSEOX_lI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_aeb35ccf57ad66ef293f39b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_354803b1377ea59aa96c6952",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6ff50299cb9e41033e163423",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_0afb213068a02bb2872be2b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_eb951690e82c1326a0f22edd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_519d06b57bc7bcdbaf4560aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_08eb87c9f5492762a4e3cfa1",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "rating": "5",
      "name": "Quenya McMillan",
      "text": "Pablo was more than helpful — a total turnaround from what I’ve experienced since moving into the Quinn residence. I submitted a maintenance order for my light bulbs, and he responded in less than 24 hours. He showed up exactly when he said he would, changed the bulbs he had, and even ran out but made sure to update me right away on which ones were pending and when he’d be back to finish.\n\nWhat really stood out to me was his professionalism and kindness. He took the time to listen while I vented about my frustrations with the property — even though he works for the company, he handled it with patience and respect. Where he could help, he truly did, going above and beyond to make sure I was satisfied.\n\nI really appreciate Pablo’s excellent customer service, timeliness, and willingness to make things right. He’s exactly the kind of employee every company should have!",
      "date": "2025-10-10",
      "title": "false"
    },
    {
      "id": "ec_28ba6c51032715449e8d810f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "rating": "5",
      "name": "ariyana",
      "text": "I currently been living here since the start of the year and i love it here, all utilities are included with my base rent and other great package qualities included so i just pay everything in one bill instead of ton of extra stressful bills . I can’t complain the black  woman who helped me lease she is so welcoming and nice every time i approach her and have a interaction she is understanding and open, I thank god i chose my townhouse , it really is a great home for what it’s worth ! For what i pay it’s completely worth it in this peaceful and quiet environment. Not to mention, maintenance is quick and efficient! The kids and Dogs love it too! The only drawback is because they are just newly built there isn’t any park or pool so it would be wonderful if that is built into this new diverse community! Thank You for this wonderful experience at Towns on Church!",
      "date": "2025-06-09",
      "title": "false"
    },
    {
      "id": "ec_ec8fbc2bb7cf6caaa77cc7a8",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "rating": "5",
      "name": "Key Flippin Management",
      "text": "Maintenance was Swift & Punctual. Thank you Pablo!",
      "date": "2025-11-03",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_1d78fe0b-4b38-4fae-8910-9cf8e838a883",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Kennedy townhome (3 bed, 2.5 bath, 1,766 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Kennedy",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=CJeyNCtixaK"
    },
    {
      "id": "custom_6981539c-a454-4166-82f9-91d8cc297e1c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Manning townhome (3 bed, 3.5 bath, 1,764 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Manning",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=yza5HrUozdZ"
    },
    {
      "id": "custom_18443a0b-35eb-4af6-8d72-a7ebd2fe3b6a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "3D walkthrough of the Richard townhome (4 bed, 3.5 bath, 1,765 sq ft)",
      "virtual_tour_thumbnail": null,
      "virtual_tour_thumbnail_media": null,
      "virtual_tour_title": "Richard",
      "virtual_tour_type": "Matterport",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7tADxWsrf1L"
    }
  ],
  "faqs": [
    {
      "id": "custom_0b8f557e-e76b-453f-8868-b2fc751a5e2c",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_60a8407f-61d4-46e4-b7dc-c3a13a20b34e",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_71a1ff81-475a-456c-8c96-3d2927ac52bf",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_d1f4b271-184e-4705-ac8a-baf8bb631f90",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_67d06349-de13-4f37-a229-bd15fb6e926f",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_d972fefb-a161-4548-96eb-039c3d7b13a6",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_bc7305ba-9b68-464f-b447-0de437e85f82",
      "question": "Landscape Services",
      "answer": "Townhomes: $45/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_6124ea85-cc65-4fc4-b0ac-15d92b925cda",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_77b58d45-77cd-4188-bbba-34f8cb352386",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_7628a43e-9c49-46b5-b2f9-5985e8bdcbe9",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_c8a31691-037c-49fb-8125-a0cb69f0464e",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_62db24a3-f07a-4f4a-ad96-93c30a859561",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_b9cc36b5-6d8e-437f-9524-2e35bf876e09",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_1f6e6d8d-d4f3-49d1-81ee-85c0dfa127f6",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_40c111bd-7769-4a18-bcc9-3f06e039c786",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_40693d3a-297a-40c6-8974-7f0bd426e3c8",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_f58f229b-e998-4b10-878d-652f6fb158f1",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_6ed32332-1538-475f-be42-2e3e4fb75980",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_e543ce5c-1616-4d11-8331-080b070a44c9",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_08ab428af1865eac9e7ba95f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "yardi",
      "external_id": "2401666",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 350,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-a4f0-76bf-a046-caf14c0d2ab0",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Towns on Church Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646"
    },
    {
      "lead_collector_id": "01a0abe0-a567-74c0-8675-86ddecc08124",
      "lead_source": "LANDING_PAGE",
      "name": "Towns on Church Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-with-in-unit-laundry-decatur-ga",
      "search_query": "apartments with in-unit laundry Decatur GA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Decatur GA",
      "h2_subtitle": "Discover the comfort of Towns on Church, where we offer apartments with in-unit laundry. Enjoy top-notch amenities in vibrant Decatur, GA.",
      "page_copy": "Discover modern townhomes with in-unit laundry in Decatur, GA, at Towns on Church. Located in DeKalb County, our community offers thoughtfully designed rental homes with convenient features that make everyday living easier. Enjoy the flexibility of doing laundry on your own schedule, along with spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to your living space.\n\nBeyond your front door, Towns on Church offers lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Spend less time managing everyday tasks and more time enjoying your home or exploring Decatur's local restaurants, shopping, parks, and attractions. With modern townhome features, convenient amenities, and access to the surrounding area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry - Decatur GA",
      "seo_description": "Discover townhomes with in-unit laundry in Decatur, GA, at Towns on Church. Enjoy spacious closets, modern finishes, and everyday convenience. Tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "smart-home-technology-apartments-near-30033",
      "search_query": "smart-home technology apartments near 30033",
      "category": "Amenity",
      "h1_title": "Smart-Home Tech Apartments Near 30033",
      "h2_subtitle": "Discover Towns on Church apartments near 30033, equipped with cutting-edge smart-home technology for modern living.",
      "page_copy": "Embrace cutting-edge living at Towns on Church, where our smart-home technology apartments near the 30033 area offer a seamless blend of convenience and innovation. Residents can enjoy a modern lifestyle with integrated smart-home features alongside luxurious amenities such as spacious closets and luxury flooring.\n\nLocated in the heart of Decatur, GA, in DeKalb County, our community is designed to enhance your living experience. From the elegance of granite countertops to the ease of a security deposit alternative, Towns on Church meets all your needs. We even take care of lawn maintenance, allowing you more time to engage with the vibrant local culture.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Tech Apartments Near 30033",
      "seo_description": "Live smarter at Towns on Church near 30033, featuring smart-home technology. Enjoy modern amenities and a convenient location in Decatur, GA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "spacious-closets-apartments-decatur",
      "search_query": "spacious closets apartments in Decatur",
      "category": "Amenity",
      "h1_title": "Spacious Closets Apartments in Decatur",
      "h2_subtitle": "Towns on Church offers beautiful apartments in Decatur with spacious closets and other luxurious amenities.",
      "page_copy": "Discover modern townhomes with spacious closets in Decatur, GA, at Towns on Church. Located in DeKalb County, our community offers thoughtfully designed rental homes with generous storage space and contemporary finishes that bring comfort and functionality to everyday living. Enjoy spacious closets for organizing clothing, accessories, and household essentials, along with granite countertops and stylish flooring that make your home feel inviting.\n\nBeyond your front door, Towns on Church offers convenient features, including lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local restaurants, shopping, parks, and attractions while enjoying the convenience of modern townhome living. With spacious storage, contemporary interiors, and practical amenities, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Closets Apartments - Decatur",
      "seo_description": "Discover spacious closet apartments at Towns on Church in Decatur. Experience luxury living with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "granite-countertops-apartments-scott-blvd-ga",
      "search_query": "granite countertops apartments Scott Blvd GA",
      "category": "Amenity",
      "h1_title": "Granite Countertops Apartments on Scott Blvd, GA",
      "h2_subtitle": "Towns on Church apartments on Scott Blvd, GA, feature exquisite granite countertops and more luxury amenities.",
      "page_copy": "Discover modern townhomes with granite countertops in Decatur, GA, at Towns on Church. Located in DeKalb County, our community offers thoughtfully designed rental homes with contemporary interiors and convenient access to local shopping, dining, and attractions. Enjoy stylish granite countertops that bring a polished look to your kitchen, along with spacious closets and modern flooring that combine comfort and functionality.\n\nBeyond your front door, Towns on Church offers practical conveniences, including lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local restaurants, shops, parks, and attractions while enjoying the comfort of your thoughtfully designed townhome. With contemporary finishes, convenient amenities, and access to the surrounding area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Granite Countertops Apts on Scott Blvd, GA",
      "seo_description": "Explore Towns on Church on Scott Blvd, GA. Enjoy granite countertops and modern amenities in a prime Decatur location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-decatur-ga",
      "search_query": "three bedroom apartments decatur ga",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Decatur, GA",
      "h2_subtitle": "Find spacious three bedroom apartments in the heart of Decatur, GA, at Towns on Church, featuring luxury amenities and a prime location.",
      "page_copy": "Discover spacious three-bedroom townhomes for rent in Decatur, GA, at Towns on Church. Located in DeKalb County, our community offers thoughtfully designed floor plans with generous living spaces, versatile bedrooms, and modern features that bring comfort and functionality to everyday living. Enjoy spacious closets, granite countertops, and stylish flooring that create an inviting space to call your own.\n\nBeyond your front door, Towns on Church offers convenient features, including lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Whether you're relaxing at home, entertaining guests, or exploring Decatur's local restaurants, shopping, parks, and attractions, our three-bedroom townhomes provide room to make the space your own. Schedule a tour today and discover the comfort and convenience of modern townhome living at Towns on Church!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments - Decatur, GA",
      "seo_description": "Discover spacious three bedroom apartments at Towns on Church in Decatur, GA, with luxury amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-near-emory-university-decatur",
      "search_query": "apartments near Emory University Decatur",
      "category": "School",
      "h1_title": "Apartments Near Emory University, Decatur",
      "h2_subtitle": "Explore Towns on Church, offering stylish apartments near Emory University in Decatur, with luxurious amenities and a welcoming community.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to local destinations like Emory University. Located in DeKalb County, our community offers thoughtfully designed rental homes with contemporary interiors and convenient access to shopping, dining, and attractions. Enjoy spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nTowns on Church also offers convenient features, including lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore destinations throughout Decatur and DeKalb County, including Emory University, local restaurants, shopping, and outdoor recreation opportunities. With modern townhome features, practical amenities, and access to the surrounding area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Emory University - Decatur",
      "seo_description": "Find luxurious living close to Emory University at Towns on Church in Decatur. Stylish spaces and prime convenience await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "towns-on-church-apartments-near-scad-atlanta",
      "search_query": "Towns on Church apartments near SCAD Atlanta",
      "category": "School",
      "h1_title": "Towns on Church: Apartments Near SCAD Atlanta",
      "h2_subtitle": "Discover Towns on Church, offering beautifully appointed apartments near SCAD Atlanta, complete with luxury finishes and convenient amenities.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to destinations throughout the Atlanta area, including SCAD Atlanta. Located in DeKalb County, our community offers thoughtfully designed rental homes featuring spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local restaurants, shops, parks, and cultural attractions, or discover destinations throughout Atlanta, including SCAD Atlanta and nearby entertainment options. Whether you're spending time at home or exploring the surrounding area, Towns on Church combines modern interiors with practical conveniences. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Towns on Church - Apts Near SCAD Atlanta",
      "seo_description": "Live comfortably near SCAD Atlanta at Towns on Church in Decatur, GA. Stylish spaces with premium amenities await.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "decatur-apartments-near-gsu-perimeter-college",
      "search_query": "Decatur apartments near Georgia State University Perimeter College",
      "category": "School",
      "h1_title": "Decatur Apartments Near GSU Perimeter College",
      "h2_subtitle": "Live close to Georgia State University Perimeter College at Towns on Church, where convenience meets luxury in every thoughtfully designed apartment.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to destinations throughout DeKalb County, including Georgia State University Perimeter College. Our community offers thoughtfully designed rental homes featuring spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local restaurants, shops, parks, and cultural attractions, along with destinations throughout the surrounding area, including Georgia State University Perimeter College. Whether you're spending time at home or discovering more of DeKalb County, Towns on Church combines modern interiors with practical conveniences. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Decatur Apts Near GSU Perimeter College",
      "seo_description": "Find luxury Decatur apartments near GSU Perimeter College at Towns on Church. Enjoy upscale living with prime access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-close-to-oglethorpe-university-ga",
      "search_query": "apartments close to Oglethorpe University GA",
      "category": "School",
      "h1_title": "Apartments Close to Oglethorpe University, GA",
      "h2_subtitle": "Discover the convenience of living near Oglethorpe University with Towns on Church, featuring luxury amenities and modern designs.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to destinations throughout DeKalb County, including Oglethorpe University. Our community offers thoughtfully designed rental homes featuring spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local restaurants, shops, parks, and cultural attractions, or discover destinations throughout the surrounding area, including Oglethorpe University. Whether you're spending time at home or exploring more of DeKalb County, Towns on Church combines modern interiors with practical conveniences. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Oglethorpe University GA",
      "seo_description": "Experience luxury living close to Oglethorpe University at Towns on Church in Decatur. Enjoy modern amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-near-south-college-atlanta-dekalb-county",
      "search_query": "apartments near South College Atlanta DeKalb County",
      "category": "School",
      "h1_title": "Apartments Near South College, DeKalb County",
      "h2_subtitle": "Find a vibrant home near South College Atlanta in DeKalb County at Towns on Church, offering modern amenities and stylish living spaces.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to destinations throughout DeKalb County, including South College Atlanta. Our thoughtfully designed rental homes feature spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local restaurants, shops, parks, and entertainment options, or discover attractions throughout the greater Atlanta area. Whether you're relaxing at home or exploring the surrounding community, Towns on Church combines contemporary interiors with practical conveniences and a welcoming atmosphere. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near South College Atlanta, DeKalb County",
      "seo_description": "Towns on Church offers stylish apartments near South College Atlanta, in DeKalb County. Enjoy a convenient lifestyle with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-near-emory-university-hospital-decatur",
      "search_query": "apartments near Emory University Hospital Decatur",
      "category": "Hospital",
      "h1_title": "Apartments Near Emory University Hospital Decatur",
      "h2_subtitle": "Discover the comfort of living close to Emory University Hospital Decatur with Towns on Church, offering luxurious and convenient apartments.",
      "page_copy": "Discover modern homes for rent near Emory University Hospital Decatur in Decatur, GA, at Towns on Church. Located in DeKalb County, our community offers thoughtfully designed rental homes with contemporary interiors and access to local shopping, dining, and attractions. Enjoy spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to your everyday routine.\n\nTowns on Church also offers convenient features, including lawn maintenance services and a security deposit alternative that may provide additional flexibility during the leasing process. Explore destinations throughout Decatur, including Emory University Hospital Decatur, local restaurants, shopping, and entertainment options. With modern home features, convenient amenities, and access to the surrounding area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our rental homes in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Emory University Hospital Decatur",
      "seo_description": "Live near Emory University Hospital Decatur at Towns on Church. Enjoy luxury and convenience with easy access to work and play.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-close-to-arthur-m-blank-hospital-dekalb",
      "search_query": "apartments close to Arthur M. Blank Hospital DeKalb County",
      "category": "Hospital",
      "h1_title": "Apartments Close to Arthur M. Blank Hospital",
      "h2_subtitle": "Explore living options near Arthur M. Blank Hospital in DeKalb County at Towns on Church, where comfort meets convenience and style.",
      "page_copy": "Discover modern homes for rent near Arthur M. Blank Hospital in Decatur, GA, at Towns on Church. Located in DeKalb County, our community offers thoughtfully designed rental homes with contemporary interiors and access to local shopping, dining, and attractions. Enjoy granite countertops, spacious closets, and stylish flooring that bring comfort and functionality to your everyday routine.\n\nTowns on Church also offers convenient features, including lawn maintenance services and a security deposit alternative that may provide additional flexibility during the leasing process. Explore destinations throughout Decatur and DeKalb County, including Arthur M. Blank Hospital, local restaurants, shopping, and entertainment options. With modern home features, convenient amenities, and access to the surrounding area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our rental homes in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Arthur M. Blank Hospital DeKalb",
      "seo_description": "Towns on Church offers comfortable apartments close to Arthur M. Blank Hospital, merging style with convenience in DeKalb County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-near-atlanta-botanical-garden-dekalb",
      "search_query": "apartments near atlanta botanical garden dekalb county",
      "category": "Park",
      "h1_title": "Apartments Near Atlanta Botanical Garden",
      "h2_subtitle": "Live close to the inspiring Atlanta Botanical Garden in DeKalb County by choosing Towns on Church, a community that embraces comfort and modern living.",
      "page_copy": "Discover modern homes for rent in Decatur, GA, at Towns on Church, with access to destinations across the Atlanta area, including the Atlanta Botanical Garden. Located in DeKalb County, our community features thoughtfully designed rental homes with spacious closets, granite countertops, and stylish flooring for everyday comfort.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local parks, restaurants, and shops, or plan a visit to the Atlanta Botanical Garden to enjoy its beautiful displays and seasonal exhibits. Whether you're spending time at home or discovering attractions throughout the region, Towns on Church brings together modern interiors and practical conveniences. Schedule a tour today to explore our homes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Atlanta Botanical Garden, DeKalb",
      "seo_description": "Towns on Church provides stylish apartments near the Atlanta Botanical Garden in DeKalb County, where nature and luxury living meet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "townhomes-close-to-piedmont-park-ga",
      "search_query": "townhomes close to piedmont park ga",
      "category": "Park",
      "h1_title": "Townhomes Close to Piedmont Park GA",
      "h2_subtitle": "Experience vibrant living near Piedmont Park, GA with Towns on Church, offering stylish townhomes and an unbeatable location.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to attractions throughout the Atlanta area, including Piedmont Park. Located in DeKalb County, our community offers thoughtfully designed rental homes featuring granite countertops, spacious closets, and stylish flooring that bring comfort and functionality to your everyday routine.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local shopping, dining, and parks, or plan a visit to Piedmont Park for walking trails, outdoor recreation, and scenic green spaces. With modern home features, convenient amenities, and access to destinations throughout the Atlanta area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Townhomes Close to Piedmont Park GA",
      "seo_description": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to Atlanta attractions like Piedmont Park. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "living-near-mason-mill-park-decatur",
      "search_query": "living near mason mill park decatur",
      "category": "Park",
      "h1_title": "Living Near Mason Mill Park Decatur",
      "h2_subtitle": "Embrace a lifestyle close to Mason Mill Park in Decatur with Towns on Church, offering comfort and convenience in a prime location.",
      "page_copy": "Discover modern townhomes for rent near Mason Mill Park in Decatur, GA, at Towns on Church. Located in DeKalb County, our community offers thoughtfully designed rental homes with contemporary interiors and access to local parks, shopping, dining, and outdoor recreation. Enjoy spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to your everyday routine.\n\nTowns on Church also offers convenient features, including lawn maintenance services and a security deposit alternative that may provide additional flexibility during the leasing process, subject to eligibility and terms. Explore Mason Mill Park and other attractions throughout Decatur, from scenic outdoor spaces to local restaurants and shopping. With modern townhome features, convenient amenities, and access to the surrounding area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Mason Mill Park Decatur",
      "seo_description": "Explore Towns on Church for an ideal living experience near Mason Mill Park, Decatur. Combining comfort with a convenient park-side location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "rentals-by-beltline-bridge-ponce-city-market",
      "search_query": "rentals by beltline bridge ponce city market",
      "category": "Park",
      "h1_title": "Rentals by Beltline Bridge Ponce City Market",
      "h2_subtitle": "Discover the charm of living near the Beltline Bridge and Ponce City Market with Towns on Church. Stylish rentals in the heart of convenience.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to Atlanta-area destinations like Ponce City Market and the Atlanta BeltLine. Located in DeKalb County, our community offers thoughtfully designed rental homes featuring spacious closets, granite countertops, and stylish flooring that bring comfort and convenience to everyday living.\n\nEnjoy lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Spend time exploring Decatur's restaurants, shops, and parks, or plan a trip to Ponce City Market for dining and shopping and the Atlanta BeltLine for outdoor recreation. Whether you're enjoying a quiet evening at home or discovering more of the Atlanta area, Towns on Church combines practical features with inviting living spaces and a location that puts local destinations within reach. Explore our townhomes for rent in Decatur, GA, and schedule a tour to see what makes this community a place to call home!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Beltline Bridge, Ponce City Market",
      "seo_description": "Towns on Church offers luxury rentals by the Beltline Bridge and Ponce City Market. Enjoy modern amenities and perfect location convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-near-decatur-square-30033",
      "search_query": "apartments near decatur square 30033",
      "category": "Park",
      "h1_title": "Apartments Near Decatur Square 30033",
      "h2_subtitle": "Find your ideal home near Decatur Square. Towns on Church offers modern apartments in the vibrant 30033 zip code area.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to local destinations like Decatur Square. Located in DeKalb County, our community offers thoughtfully designed rental homes featuring spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur Square's local restaurants, shops, and cultural attractions, or discover nearby parks and entertainment options throughout the Decatur area. Whether you're spending time at home or exploring the surrounding community, Towns on Church combines modern interiors with practical conveniences. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Decatur Square 30033",
      "seo_description": "Explore Towns on Church for stylish apartments near Decatur Square in the 30033 area. Enjoy luxury living with urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-near-arts-center-martinez-decatur-ga",
      "search_query": "apartments near arts center martinez decatur ga",
      "category": "Transit",
      "h1_title": "Apartments Near Arts Center Martinez Decatur",
      "h2_subtitle": "Explore living near the Arts Center Martinez in Decatur, GA with Towns on Church, offering a creative and comfortable lifestyle.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to arts, culture, and entertainment throughout the surrounding area. Located in DeKalb County, our community offers thoughtfully designed rental homes featuring spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local galleries, cultural attractions, restaurants, and shops, or discover arts and entertainment destinations throughout the greater Atlanta area. Whether you're spending time at home or exploring the surrounding community, Towns on Church combines modern interiors with practical conveniences. Schedule a tour today and discover our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Arts Center Martinez Decatur",
      "seo_description": "Discover Towns on Church, with elegant apartments near the Arts Center Martinez in Decatur, GA. Enjoy vibrant living close to cultural attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "living-near-lindbergh-center-dekalb-county",
      "search_query": "living near lindbergh center dekalb county",
      "category": "Transit",
      "h1_title": "Living Near Lindbergh Center in DeKalb County",
      "h2_subtitle": "Experience the convenience of living near Lindbergh Center in DeKalb County with Towns on Church, combining comfort with urban accessibility.",
      "page_copy": "Discover modern townhomes for rent in Decatur, GA, at Towns on Church, with access to destinations throughout the Atlanta area, including Lindbergh Center. Located in DeKalb County, our community offers thoughtfully designed rental homes featuring spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to everyday living.\n\nEnjoy the convenience of lawn maintenance services and a security deposit alternative, subject to eligibility and terms. Explore Decatur's local restaurants, shops, and parks, or plan a visit to Atlanta's Lindbergh Center area for additional shopping, dining, and transportation options. Whether you're spending time at home or discovering destinations throughout the region, Towns on Church combines modern interiors with practical conveniences. Schedule a tour today and explore our townhomes for rent in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Lindbergh Center, DeKalb County",
      "seo_description": "Enjoy modern living near Lindbergh Center in DeKalb County with Towns on Church. Discover the perfect balance of comfort and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "apartments-close-to-indian-creek-decatur-georgia",
      "search_query": "apartments close to indian creek decatur georgia",
      "category": "Transit",
      "h1_title": "Apartments Close to Indian Creek, Decatur",
      "h2_subtitle": "Towns on Church offers comfortable living in Decatur, near the Indian Creek area, with top-notch amenities and convenient access.",
      "page_copy": "Discover modern homes for rent near Indian Creek in Decatur, GA, at Towns on Church. Our community offers thoughtfully designed rental homes with contemporary interiors and access to local shopping, dining, parks, and attractions. Enjoy spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to your everyday routine.\n\nBeyond your front door, Towns on Church offers convenient community features, including lawn maintenance services and a security deposit alternative that may provide additional flexibility during the leasing process. Explore destinations throughout Decatur, including the Indian Creek area, local restaurants, shopping, and outdoor recreation opportunities. With modern home features, convenient amenities, and access to the surrounding area, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our rental homes in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Indian Creek, Decatur, GA",
      "seo_description": "Discover Towns on Church in Decatur for elegant apartments close to Indian Creek. Enjoy comfort and convenience in a vibrant location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167646",
      "source": "custom",
      "page_item_url": "find-apartments-near-decatur-transit-30033",
      "search_query": "find apartments near decatur transit 30033",
      "category": "Transit",
      "h1_title": "Find Apartments Near Decatur Transit 30033",
      "h2_subtitle": "Towns on Church offers prime living options near Decatur transit in the 30033 area, blending convenience with comfort.",
      "page_copy": "Discover modern homes for rent near public transportation in Decatur, GA, at Towns on Church. Located in the 30033 area, our community offers thoughtfully designed rental homes with contemporary interiors and access to local shopping, dining, and attractions. Explore transportation options throughout Decatur while enjoying the comfort and convenience of modern rental home living.\n\nInside your home, enjoy spacious closets, granite countertops, and stylish flooring that bring comfort and functionality to your everyday routine. Towns on Church also offers lawn maintenance services and a security deposit alternative, providing additional convenience and flexibility during the leasing process. With modern home features, convenient amenities, and access to Decatur's local attractions, Towns on Church offers a welcoming place to call home. Schedule a tour today and discover our rental homes in Decatur, GA!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Decatur Transit 30033",
      "seo_description": "Explore Towns on Church for apartments near Decatur transit in 30033. Enjoy luxury amenities with easy access to transport.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977247768"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W3SLRF9P"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57164436260"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/1ywykk47vq0"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/97c72ddf-da55-4fc0-bd34-27316223dba2/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "f575fe0c-ff93-11ef-945a-5358b7291f6b"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-410-7680"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "877-395-8448"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977247768",
  "custom_google_gtm_id": "GTM-W3SLRF9P",
  "custom_rollout_phase": "Phase 2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57164436260",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/1ywykk47vq0",
  "custom_self_guided_tour_url": "https://selftournow.com/property/97c72ddf-da55-4fc0-bd34-27316223dba2/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "f575fe0c-ff93-11ef-945a-5358b7291f6b",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "844-410-7680",
  "custom_paid_social_tracking_phone_number": "877-395-8448",
  "custom_audioeye_site_id": "31be68bc-6dda-499a-b0c2-9b50884d1492",
  "custom_audioeye_site_hash": "4ab5e0778cef8de99de1d4bc89954f56"
};

export const generatedAt = '2026-10-29T18:32:41.786Z';
